import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { TranslateService } from "@ngx-translate/core";
import { SearchHeaderService } from "../../services/SsearchHeader.service";

import moment from "moment";
import { PatientNotesDialogComponent } from "../patient-notes-dialog/patient-notes-dialog.component";
import { forkJoin, Observable, of, Subject, Subscription } from "rxjs";
import { catchError, map, switchMap, takeUntil } from "rxjs/operators";
import { removeSpaces } from "../../helper/helper.service";
import { mandatoryFields } from "../../properties/field-mandatory-properties";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { patientGetDataservice } from "../../services/SpatientGetData.service";
import { MasterUrlService } from "../../services/SmasterUrl.service";
import { CameraDialogComponent } from "../../shared/camera-dialog/camera-dialog.component";
import { RegsuccessDialogComponent } from "../../shared/regsuccess-dialog/regsuccess-dialog.component";
import {
  OPD_REPORT_NAME,
  OPD_REPORT_TYPE,
} from "../../properties/opd-report-properties";
import { opdNavigation } from "../../properties/opd-navigation-properties";
import {
  baseObj,
  printObject,
  priviousEncounterObject,
} from "../../interface/IerRegistration";
import { mandatoryFieldsService } from "../../services/SmandatoryFields.service";
import { statisGlApprovalType } from "../../enums/encounter-status.enum";
import { HttpClient } from "@angular/common/http";
import { PatientRegistrationService } from "../../services/Spatient-registration.service";
import { MASTERSSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/master-service";
import { MasterKeys, MasterSubMenus } from "projects/lib/medcare-core-lib/src/lib/constants/configuration-modules.constants";
import { STATICCODESERVICE } from "projects/lib/medcare-core-lib/src/lib/constants/static-code-service";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { ConfirmDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dialog/confirm-dialog.component";
import { ConfirmDynamicDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dynamic-dialog/confirm-dynamic-dialog.component";
import { InfoDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/info-dialog/info-dialog.component";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { dupicatePatient, Langauge, MasterMenus } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
import { BirthPlaceList } from "projects/lib/medcare-core-lib/src/lib/regproperties/birth-place";
import { ApplicationConfigService } from "projects/lib/medcare-core-lib/src/lib/services/application-config.service";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";
import { PatientEncounterPayer, PatientNextOfKin, PatientRegistration } from "projects/lib/medcare-core-lib/src/lib/services/RegistationModel";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { UtilsService } from "projects/lib/medcare-core-lib/src/lib/services/utils.service";
import { MyKadData } from "projects/lib/medcare-core-lib/src/lib/regmodels/MmyKadData";
import { OPD_CONST } from "projects/lib/medcare-core-lib/src/lib/regproperties/opd-static-properties";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { Identification } from "projects/lib/medcare-core-lib/src/lib/regmodels/MpatientRegistration";
import { DuplicatePatientService } from "projects/lib/medcare-core-lib/src/lib/regservices/SduplicatePatient.service";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { Router } from "@angular/router";
import { AesEncryptionService } from "projects/lib/medcare-core-lib/src/lib/services/aes-encryption.service";
import { CARD_READER_TYPE } from "projects/lib/medcare-core-lib/src/lib/constants/card-reader-constants";
import { CardReaderService } from "projects/lib/medcare-core-lib/src/lib/services/card-reader.service";
import { EnvoirnmentService } from "projects/lib/medcare-core-lib/src/lib/services/envoirnment.service";
import { PdpaFormService } from "projects/lib/medcare-core-lib/src/lib/regservices/pdpa-form.service";
import { PatientLableService } from "projects/lib/medcare-core-lib/src/lib/regservices/patient-lable.service";
import { EncounterSlipService } from "projects/lib/medcare-core-lib/src/lib/regservices/encounter-slip.service";

@Component({
  selector: "app-emergency-registration",
  templateUrl: "./emergency-registration.component.html",
  styleUrls: ["./emergency-registration.component.scss"],
  providers: [DatePipe],
})
export class EmergencyRegistrationComponent implements OnInit, OnDestroy {
  private subscriptionList = new Subscription();
  patientId: string = "";
  patientForm: boolean = true;
  patientImage: string = "";
  isDeceased: boolean = false;
  printPayload: printObject;
  selectedPatient: any;
  searchCriteria: any = null;
  patientList: [] = [];
  refreshTime: string = "";
  hidePatientSearch = false;
  isBothAddressSame: boolean = false;
  patientInfoDisplay: string = "";
  previousEncounterList: any[] = [];
  dataSourceEncounters = new MatTableDataSource<priviousEncounterObject>([]);
  unitName: string;
  isRegistered: boolean = false;
  username: string;
  userId: number;
  usermasterid: number;
  patientTRN: string = "";
  isDisabled: boolean = false;

  isAdmissionRequest: boolean = false;

  dipartmentSearch: FormControl = new FormControl();
  departmentFilterLists:any[]=[];
  departmentLists:any[]=[];

  payerTypeSearch: FormControl = new FormControl();
  payerSearch: FormControl = new FormControl();
  tariffSearch: FormControl = new FormControl();
  contractCodeSearch: FormControl = new FormControl();
  associatedCompanySearch: FormControl = new FormControl();

  displayedColumnsEncounters: string[] = OPD_CONST.displayColumnEncounters;

  primaryIdList: any[] = [];
  primaryIdFilteredList: any[]=[];
  secondaryIdList: any[] = [];
  secondaryIdFilteredList: any[] = [];

  appointmentReference: {
    appointmentId: string;
    tempPatientId: string;
    trnNumber: string;
    doctorCode: string;
    departmentCode: string;
  } = {
    appointmentId: "",
    tempPatientId: "",
    trnNumber: "",
    doctorCode: "",
    departmentCode: "",
  };

  genderValue: any = null;
  identifierTypeValue: [] = null;
  titleValue: any = null;

  encounterTypeValue: [] = null;
  departmentValue: [] = null;
  departmentValues:any=null;
  doctorValue: [] = null;

  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth();
  day = this.now.getDate();
  minDate = moment().add(-200, 'year').toDate();
  maxDate = new Date(this.year, this.month, this.day);
  maxExpiry = new Date(this.year + 20, this.month, this.day);
  primaryIdRegex: string = OPD_CONST.primaryIdRegix;
  isexpiryDate: boolean = false;
  isValid: boolean = false;
  patientAge: {
    years: string;
    months: string;
    days: string;
  } = {
    years: "0",
    months: "0",
    days: "0",
  };
  masterAPI: any = MASTERSSERVICES;
  mandatoryField: any = mandatoryFields;
  unitCode: string;
  formRegistration: FormGroup;

  //--End Registration Details---//

  formEncounter: FormGroup;
  _onDestroy: Subject<boolean> = new Subject<boolean>();
  isDepartment: boolean = true;
  isPassport: boolean = false;
  doctorSearch: FormControl = new FormControl();
  doctorFilteredList: any = [];
  internalNotesList: [] = [];
  previousInternalNotes: [] = [];
  internotesEncounterid: number;
  internotesEncounterNo:number;
  selected: string;
  encounternumber: string = "";
  minIdentificationLength:number=0;
  maxIdentificationLength:number=20;
  
  //-----Encounter Details End Here-----//

  //payer Details//
  displayedColumnsPayers: string[] = OPD_CONST.displayColumnPayers;
  dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>([]);
  payerList: any[] = [];
  payerTypeList: any[] = [];
  tariffList: any[] = [];
  contractList: [] = [];
  associatedCompanyList: [] = [];
  glTypeList: [] = [];

  payerTypeFilteredList: any;
  payerFilteredList: any;
  tariffFilteredList: any;
  contractCodeList: any;
  associatedCompanyCodeList: any;
  docList: any;
  ////---payer Ends Here---//
  admissionStatus: boolean;
  medicalReport: boolean;
  doctorValueappointment: any;
  mandatorykeys: mandatoryFieldsService = new mandatoryFieldsService();
  appointmentData: null;
  mrdDepartment:string='';
  opdSpeciality: any;
  multiLangDoctorList: any[] = [];
  isSelectedPatient: boolean=false;
  isFirstPayerPriority: boolean;
  existingPayerList: any;
  contractValue: any=[];
  isVip: boolean = false;
  isNoteVisible?:string
  mobileNoMax: number= 14;
  mobileNoMin: number= 8;
  isDefaultDeposit: boolean = false;
  defaultDeposit: string = "";

  identificationTypeList: any[];
  genderList: any[] = [];
  raceList: any[] = [];
  religionList: any[] = [];
  orgCode: string='';
  isSUHCOrg: boolean = false;
  defaultCountry:string='';
  countryCode: string;
  countryCodeLists: any[]=[];
  showFields:boolean = true;
  isDisabledName: boolean = false;
  output: string;
  selectedPrimaryId: string;
  countryPrimaryList: any[] = [];
  statePrimaryList: any[] = [];
  cityPrimaryList: any[] = [];
  subDistrictPrimaryList: any[] = [];
  stateValue: any = null;
  cityValue: any = null;
  districtValue: any = null;
  postCodeValue: any = null;
  CountryCode: any = null;
  StateCode: any = null;
  CityCode: any = null;
  countryValue: any =  null;
  isPrimaryNoEditable:boolean=false;
  langaugeValue:string;
  defaultIdentification: string='';
  primaryIdCode: any;
  primaryIdNewValue: any;
  displayedColumns: string[] = OPD_CONST.identificationTable;
  identificationList = new MatTableDataSource<Identification>([]);

  @ViewChild(MatTable) tableidentification!: MatTable<Identification>;
  selectedPatientIdentificationList:Identification[]=[];
  primaryIdentifierListModified: boolean;
  secondaryIdentifierListModified: boolean;
  countrySearch: FormControl = new FormControl();
  primaryIdSearch: FormControl = new FormControl();
  secondaryIdSearch: FormControl = new FormControl();
  countryList: any[] = [];
  uhId: string = "";
  isFromAnotherunit: boolean = false;
  private duplicateCheckCalled: { [key: string]: boolean } = {
    identificationNo: false,
    dateOfBirth: false,
    mobileNumber: false
  };

  formNextOfKin: FormGroup;
  displayedColumnsNOKs: string[] = OPD_CONST.displayColumnNok;
  dataSourceNextOfKin = new MatTableDataSource<PatientNextOfKin>([]);
  nokList: any[] = [];
  kinData: any[] = [];
  nokCountryCode: any = null;
  nokStateCode: any = null;
  nokCityCode: any = null;
  showDefaultDeposit: boolean = true;  
  isEditNok: boolean=false;
  nokId: string = "";
  nokIid:number; 
  primaryIdFilteredListNok: any[] = [];
  primaryIdListNOK: any[] = [];
  primaryIdSearchNok: FormControl = new FormControl();
  prefixList: any[]=[];
  relationList: any[]=[];
  titleDefaultValue: string = "";
  relationDefaultValue: string = "";
  countryDefaultValue: string = "";
  stateDefaultValue: string = "";
  cityDefaultValue: string = "";
  isNOKRequired: boolean=false;
  isUnitWisePatientSearch: boolean=false;
  patientCategoryValue: string = "";
  isPatientCategory: boolean= false;

  cardReaderStatus: boolean = false;
  enableCardReaderBtn: boolean = false;
  nokAreaCode: baseObj;
  areaDefaultValue : string = "";
  defaultNationality: string = "";
  isPDPAReport: boolean=false;
  orgName: string="";
  isUnknown: boolean = false;
  configurationDrCode: string = "";
  emergencyPatientPayload: any;
  // cityNewPrimaryList: baseObj[];
  // areaNewPrimaryList: baseObj[];
  ispatientNameLtwo:boolean=false;
  isFullName:boolean=false;
  isOtherReferral: boolean = false;
  referralTypeCode: any = null;
  isKinGuarantorRequired: boolean=false;
  showAllIdentificationTypes: boolean = false;
  defaultClinic: string = "";
  isForeignerExpiryMandatory: boolean=false;
  showPatientPrefix: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private searchService: SearchService,
    private appBaseService: AppBaseService,
    public translate: TranslateService,
    public authService: AuthService,
    private patientService: PatientService,
    public applicationConfig: ApplicationConfigService,
    private patientRegService: PatientRegistrationService,
    private langService: MultiLanguageService,
    public searchHead: SearchHeaderService,
    public generalApiService: GeneralUrlService,
    public masterApiService: MasterUrlService,
    public patientDataService: patientGetDataservice,
    private utilsService: UtilsService,
    private datepipe: DatePipe,
    private httpClient: HttpClient,
    private thConvertService:thEnConverterService,
    private cdr: ChangeDetectorRef,
    private dupicatePatientService: DuplicatePatientService,
    private router: Router,
    private encryptionService:AesEncryptionService,
    private env: EnvoirnmentService,
    private pdpaFormService:PdpaFormService,
    private patientLableService:PatientLableService,
    private encounterSlipService:EncounterSlipService,
    public cardReaderService: CardReaderService
  ) {
    this.getPrimaryIdList();
  }

  /**
   *load method
   *
   * @memberof SamplePatientRegistrationComponent
   */
  ngOnInit() {
    this.addEmptyIdentificationEntry("P");
    this.formRegistration= this.formBuilder.group({
      id: [""],
      isVip: [false],
      isNewborn: [false],
      active:[false],
      mrn: [""],
      primaryId: [""],
      primaryNumber: [null, [removeSpaces]],
      expiryDate: [""],
      issuedCountryPrimary: [""],
      secondaryId: [""],
      secondaryNumber: [""],
      issuedCountrySecondary: [""],
      faculty: [""],
      firstName: [null, [removeSpaces]],
      fullName: [null, [removeSpaces]],
      middleName: [null, [removeSpaces]],
      lastName: [null, [removeSpaces]],
      firstNameTh: [null, [removeSpaces]],
      middleNameTh: [null, [removeSpaces]],
      lastNameTh: [null, [removeSpaces]],
      aliasName: [{value: '', disabled: true}, [removeSpaces]],
      isKnown :[false],
      dateOfBirth: [""],
      realdob: [false],
      prefix: [""],
      gender: [""],
      race: [""],
      nation: [""],
      patientCategory: [""],
      referralType: [""],
      referral: [""],
      martial: [""],
      occupation: [""],
      preferredLanguage: [""],
      bloodGroup: [""],
      religion: [""],
      isDeceased: [false],
      isBlock: [false],
      isCtos: [false],
      sourceType: [""],
      patientNotes: [null, [removeSpaces]],
      addressPrimary: [null, [removeSpaces]],
      countryPrimary: [""],
      statePrimary: [""],
      cityPrimary: [""],
      subDistrictPrimary: [""],
      homeContact: [""],
      personalFax: [""],
      education: [""],
      birthplace: [""],
      workFax: [""],
      motherName: [""],
      ethnic: [""],
      mobileNumber: [""],
      addressSecondary: [null, [removeSpaces]],
      countrySecondary: [""],
      stateSecondary: [""],
      citySecondary: [""],
      subDistrictSecondary: [""],
      workContact: [""],
      contactRelation: [""],
      pincodePrimary: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      pincodeSecondary: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      emailId: [
        "",
        Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-.]+$"),
      ],
      birthTime: [""],
      countryCodemobile: [""],
      secondaryExpirydate: [""]
    });
  
    //--End Registration Details---//
  
    this.formEncounter = this.formBuilder.group({
      visitToDepartment: [""],
      encounterType: [""],
      department: ["", Validators.required],
      doctor: ["", Validators.required],
      clinic: [""],
      cashCounter: [""],
      remarks: [null],
      queueNumber: [""],
      referralType: [""],
      referral: [""],
      reportType: [""],
      reportReason: [""],
      patientCategory: [""],
      practiceNotes: [null],
      visittype: ["ER"],
      referralRemarks: [null, [removeSpaces]],
      reportRemarks: [null, [removeSpaces]],
    });

    this.formNextOfKin = this.formBuilder.group({
      prefix: [""],
      name: ["", Validators.required],
      identificationType: [""],
      identificationNumber: [""],
      relation: [""],
      phoneNumber: [""],
      isGuarantor: [""],
      address: [""],
      country: [""],
      state: [""],
      city: [""],
      area: [""],
      district: [""],
      postcode: [""],
    });
    this.getCountryCode();
    this.getPreviousPayerList();
    // let patientEncounterPayer = new PatientEncounterPayer();
    // patientEncounterPayer.isSelf = true;
    // this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>([
    //   patientEncounterPayer,
    // ]);
    this.langaugeValue=localStorage.getItem("lan");
    this.fillDropDownLists();
    this.getScreenConfigurations();
    this.initSearchFilter();
    // this.getOrgAppConfigList();
    this.searchOnChanges();
    // this.getUnitData();
    this.initMyKadByConfig();

    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
    });

    // this.getFirstName();
      if (localStorage.getItem(OPD_CONST.emergencyForm)) {
      let mrn = JSON.parse(
        localStorage.getItem(OPD_CONST.emergencyForm)
      );
      this.getpatientbyId(mrn);
      this.isSelectedPatient=true;
      localStorage.removeItem(OPD_CONST.emergencyForm)
     }
  }
  getFirstName(){
    var date = new Date();
    var day = date.getDate();
    var hours = ("0" + date.getHours()).slice(-2);
    var minutes = ("0" + date.getMinutes()).slice(-2);
    var seconds = ("0" + date.getSeconds()).slice(-2);
    let name= "UNKNOWN"+"-"+day+":"+hours+":"+minutes+":"+seconds;
    const controls = this.formRegistration.controls;
    if (this.ispatientNameLtwo){
      this.formRegistration.patchValue({firstNameTh: name,});
      controls['lastNameTh']?.clearValidators();
      controls['lastNameTh']?.updateValueAndValidity(); 
    }else if(this.isFullName){
      this.formRegistration.patchValue({fullName: name,});
      controls['fullName']?.clearValidators();
      controls['fullName']?.updateValueAndValidity();
    }else{
      this.formRegistration.patchValue({firstName: name,});
      controls['lastName']?.clearValidators();
      controls['lastName']?.updateValueAndValidity();
    }
   
  }

  /**
   *get user info details
   *
   * @memberof PatientRegistrationComponent
   */
  getUserInfo() {
    this.authService.getUserInfo().then((value: any) => {
      this.username = value.userName;
      this.userId = value.userId;
      this.usermasterid = value.user_code;
    });
  }

  /**
   * To get unit data
   * @memberof SamplePatientRegistrationComponent
   */
  getUnitData() {
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
      this.unitName = value.unitDescription;
      this.orgCode=value.orgCode;
      this.isSUHCOrg = value.orgCode === "SUHC";
      this.orgName=value.orgDescription;
      this.getAppConfigurationList();
      this.getOrgAppConfigList();
    });
  }

  /**
   *Fill DropDown List
   *
   * @memberof SamplePatientRegistrationComponent
   */
  fillDropDownLists() {
    this.getCountryList();
    // this.getCityList();
    // this.getAreaList();
    this.getPayerTypeList();
    this.getPayerList();
    // this.getContractListData();
    this.getTariffmaster();
    this.getAssociatedCompanyList();
    this.getGLTypeList();  
    this.getDoctorList(null); 
    this.getdepartment();
    this.getPrefixList();
    this.getRelationList();
  }

  getdepartment() {
    this.masterApiService
      .getTypeMaster(this.masterAPI.DEPT_GET_DEPT_BY_UNIT)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.departmentLists = data.filter((dept: any) => dept.isClinicalSpeciality === true);
        this.departmentFilterLists=this.departmentLists
        this.getAppConfigList();
          // this.getOrgAppConfigList();
        this.getUnitData();
      });
  }

  /**
   *getpatient search by id
   *
   * @param {*} patientId
   * @memberof SamplePatientRegistrationComponent
   */
  getpatientbyId(patientId) {
    let reqPayload =
      "identificationId=&name=&mrn=" +
      patientId +
      "&gender=&unitCode=&city=&identificationType=&frDate=&toDate=&id=&mobile=&birthDate=&offset=&size=&pincode=&country=&state=";
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_PATIENT_SEARCH + reqPayload
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any[]) => {
        let pateintData = this.patientDataService.displayList(res);
        this.getPatientData(pateintData[0]);
      });
  }
 /**
   * application configuration source
   */

  getAppConfigList() {
    let mrdConfig: any;
    this.applicationConfig
      .getModuleConfiguration(MasterMenus.OPD, "",true)
      .subscribe((res) => {
        if (res) {
          mrdConfig = res;
          mrdConfig.forEach((element) => {
            if (element.key == "DepartmentMaster") {
              this.departmentValues =this.departmentLists.find(e=>e.code== element.valueList[0].code);
              if (element?.valueList?.length > 0 && this.departmentValues.code) {
              this.getDoctorList(this.departmentValues.code);
              }
            }
            if (element.key == MasterKeys.firstPayerPriorityRequired){
              if (element.valueList.length > 0) {
                this.isFirstPayerPriority = element.valueList[0].code=="true"?true:false;
              }
            }
            if (element.key == MasterKeys.emergencyDoctor){
              // let value = this.docList.find(i=>i.code == element.valueList[0].code)
              if (element?.valueList?.length > 0) {
                // setTimeout(() => {
                //   this.formEncounter.patchValue({
                //     doctor: value ? value.code : "",
                //   });
                // },1000);
                //   this.getSpeciality(element.valueList[0].code)
                this.configurationDrCode = element.valueList[0].code;
                this.getDoctorList(this.departmentValues.code);
              }
            }
            if (element.key == MasterKeys.isDefaultDepositRequired){
              if (element.valueList.length > 0) {
                this.isDefaultDeposit = element.valueList[0].code=="true"?true:false;
              }
            }
            if (element.key == MasterKeys.isDefaultDepositRequired){
              if (element.valueList.length > 0) {
                this.isDefaultDeposit = element.valueList[0].code=="true"?true:false;
              }
            }
           });
        }
      });
  }
  getAppConfigurationList() {
    let mrdConfig: any;
      this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
      this.appBaseService
        .getResource( "appConfiguration/findConfigByModule?unitCode="+this.unitCode+
          "&orgCode="+this.orgCode+"&moduleName="
          +OPD_CONST.patientManagement+"&keyName=")
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
        if (res) {
          mrdConfig = res.keys;
          mrdConfig.forEach((element) => {
          
            if (element.key == MasterKeys.DefaultCountryCode){
              if (element.valueList.length > 0) {
                this.defaultCountry = element.valueList[0]?.code;
                let code = this.countryCodeLists.filter(i=>i.code ==element.valueList[0]?.code)
                this.countryCode=element.valueList[0].code;
                this.setPatternToMobileNumber(code[0]);
              }
            }
            if (element.key == MasterKeys.DefaultPatientCategory) {
              if (element.valueList.length > 0) {
                this.patientCategoryValue = element.valueList[0].code ? element.valueList[0].code : "";
                this.getTariffList(element.valueList[0].code,0,true);
              }
            }
            if (element.key == MasterKeys.patientCategoryTariffRequired) {
              this.isPatientCategory =
                element.valueList[0].code == "true" ? true : false;
            }
             if (element.key == MasterKeys.defaultNationality) {
              if (element.valueList.length > 0) {
                this.defaultNationality = element.valueList[0]?.code;
              }
            }
             if (element.key == MasterKeys.ERRegistrationDefaultUnknown){
              if (element.valueList.length > 0) {
                this.isUnknown = element.valueList[0].code=="true"?true:false;
                if(this.isUnknown){
                  this.getFirstName();
                  this.formRegistration.get('isKnown').setValue(this.isUnknown);
                }
              }
            }
            if (element.key == MasterKeys.ED_Clinic) {
              if (element.key == MasterKeys.ED_Clinic) {
                if (element.valueList?.length > 0) {
                  this.defaultClinic = element.valueList[0].code;
                }
              }
            }
          });
        }
      });
  }
  getCountryCode() {
    this.masterApiService
      .getTypeMaster(this.masterAPI.COUNTRY_CODE_MASTER,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.countryCodeLists = data;
      });
  }
  /*
  Screen configuration source
  */
  getScreenConfigurations() {
    this.subscriptionList.add(
      this.applicationConfig
        .getScreenConfiguration("OPD",MasterSubMenus.ERRegistration)
        .subscribe((config:any) => {
          if (config) {
            this.mandatorykeys.setMandatoryFormValues(config, mandatoryFields);
          }
        })
    );
  }

  getOrgAppConfigList() {
    let appConfig: any;
    this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.appBaseService
      .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if (res) {
          appConfig = res.keys;
          appConfig.forEach((element) => {
            if (element.key == MasterKeys.primaryIdentification){
              if (element.valueList?.length > 0 && element.valueList[0]?.code) {
                let value = this.primaryIdFilteredList.find(i=>i.code == element.valueList[0]?.code);
                
              this.formRegistration.patchValue({
                primaryId: value.code});
                this.cdr.detectChanges();
                this.identificationList.data[0].idType=value?.code;
                this.primaryIdentificationOnChange(value ,false,0)
            }
          }
          if(element.key == MasterKeys.isUnitWisePatientSearch) {
              if (element.valueList.length > 0) {
                this.isUnitWisePatientSearch = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.ER_Auto_Print_PDPA_Form) {
              if (element.valueList.length > 0) {
                this.isPDPAReport = (element.valueList[0].code=="true")?true:false;
              }
            }
             if (element.key == "DepartmentMaster") {
              this.departmentValues =this.departmentLists.find(e=>e.code== element.valueList[0].code);
              if (element?.valueList?.length > 0 && this.departmentValues.code) {
              this.getDoctorList(this.departmentValues.code);
              }
            }
            if(element.key == MasterKeys.patientNameLtwo) {
              if (element.valueList.length > 0) {
                this.ispatientNameLtwo = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.fullName) {
              if (element.valueList.length > 0) {
                this.isFullName = (element.valueList[0].code=="true")?true:false;
              }
            }
            if(element.key == MasterKeys.SEPERATE_IDENTIFICATION_TYPE_BASED_ON_PRIMARY_FOR_SRIPHAT) {
              if (element.valueList.length > 0) {
                this.showAllIdentificationTypes = element.valueList[0].code == "true";
                this.updateIdentificationLists();
              }
            }
             if(element.key == MasterKeys.IS_KIN_GUARANTOR_REQ) {
              if (element.valueList.length > 0) {
                this.isKinGuarantorRequired = (element.valueList[0].code=="true")?true:false;
              }
            }
            if (element.key == MasterKeys.Is_Foreign_Patient_Expiry_Date_Required) {
              if (element.valueList.length > 0) {
                this.isForeignerExpiryMandatory = element.valueList[0].code === "true";
              }
            }
            if (element.key == MasterKeys.SHOW_PATIENT_PREFIX) {
              if (element.valueList.length > 0) {
                this.showPatientPrefix = (element.valueList[0].code == "true") ? true : false;
              }
            }
        });
         this.updateNameValidators();
         this.checkFields(false);
        } 
      });
  }           

  /**
   *It is the source of doctor data
   *
   * @param {*} departmentCode
   * @memberof PatientRegistrationComponent
   */
   getDoctorList(departmentCode) {
      let payload = {
        limit: 0,
        unitCode: this.unitCode,
        departmentCode: departmentCode ? departmentCode : null,
        typeCodeList: ["DR"],
      };
      this.masterApiService
        .postTypeMaster(OPD_API_URL.EMPLOYEE_LIST, payload)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((data: any) => {
          let list = [];
          let letmultilangdoclist = [];
          if (
            data &&
            data.payload &&
            data.payload.employeeResponseList &&
            data.payload.employeeResponseList.length > 0
          ) {
            data.payload.employeeResponseList.forEach((element) => {
              list.push({
                id: element.id,
                code: element.code,
                desc: element.desc,
              });
              letmultilangdoclist.push(element);
              if (this.previousEncounterList.length > 0)
                this.formEncounter.controls["doctor"].setValue(this.doctorValue);
            });
          }
          this.multiLangDoctorList = letmultilangdoclist;
          this.doctorFilteredList = list;
          this.docList = list;
          if(this.configurationDrCode){
            let value = this.docList.find(i=>i.code == this.configurationDrCode);
             this.formEncounter.patchValue({
                    doctor: value ? value.code : "",
                  });
          }
        });
  }

  getDoctorDescription(doctorCode: string): string {
    return this.docList?.find((doctor) => doctor.code === doctorCode)?.desc || '';
  }

  /**
   *Destroy mehtod
   *
   * @memberof SamplePatientRegistrationComponent
   */
  ngOnDestroy() {
    this.cardReaderService.destroy();
    this.searchService.setSearch([]);
    this.subscriptionList.unsubscribe();
  }

  /**
   *
   *
   * @memberof EmergencyRegistrationComponent
   */
  initMyKadByConfig() {
    this.getMyKadMasters();
    this.enableCardReaderBtn = this.env.cardReaderType === CARD_READER_TYPE.TRICUBES_SDK;
    // this.cardReaderService.setFormActive(this.patientForm);
    this.cardReaderService.initialize(this.env.cardReaderType);
    this.cardReaderService.cardData$
      .pipe(takeUntil(this._onDestroy))
      .subscribe((myKadData: MyKadData) => this.loadMyKadData(myKadData));
  }

  /** Delegate for the "Read Card" button (TRICUBES_SDK mode only). */
  checkStatus() {
    this.cardReaderService.triggerRead();
  }

  /**
   *
   *
   * @param {*} event
   * @memberof EmergencyRegistrationComponent
   */
  loadMyKadData(myKadData: MyKadData) {
    if (myKadData.Name) {
      const GenderCode = this.patientRegService.getCodeBySystemCode(
        this.genderList,
        myKadData.Gender ? myKadData.Gender : ""
      );

      const PrefixCode = this.patientRegService.getCodeBySystemCode(
        this.prefixList,
        myKadData.PrefixEn ? myKadData.PrefixEn : ""
      );

      // Derive the country of card origin from the card type
      const countryStaticCode =
        myKadData.CardType === STATICCODESERVICE.IDENTIFICATION_TYPE_THAIID
          ? STATICCODESERVICE.COUNTRY_THAILAND
          : STATICCODESERVICE.COUNTRY_MALAYSIA;

      const CountryCode = this.patientRegService.getCodeByStaticCode(
        this.countryPrimaryList,
        countryStaticCode
      );

      // Resolve the correct identification type code
      let cardTypeCode: string;
      if (myKadData.CardType === STATICCODESERVICE.IDENTIFICATION_TYPE_MYKAD) {
        cardTypeCode = STATICCODESERVICE.IDENTIFICATION_TYPE_MYKAD;
      } else if (myKadData.CardType === STATICCODESERVICE.IDENTIFICATION_TYPE_THAIID) {
        cardTypeCode = STATICCODESERVICE.IDENTIFICATION_TYPE_THAIID;
      } else {
        cardTypeCode = STATICCODESERVICE.IDENTIFICATION_TYPE_MYKID;
      }

      const IdType = this.patientRegService.getCodeByStaticCode(
        this.identificationTypeList,
        cardTypeCode
      );

      const dob = moment(myKadData.BirthDate, ["DD/MM/YYYY", "DD/MM/YYYY hh:mm:ss aa"])
        .format("YYYY-MM-DD");

      // Thai card provides separate first/last names; MyKad uses a single full-name field
      const firstName = myKadData.FirstNameEn || myKadData.Name;
      const lastName = myKadData.LastNameEn || "";

      this.genderValue = GenderCode;
      this.titleValue = PrefixCode;
      this.countryValue = CountryCode;
      this.getStatePrimaryList(this.countryValue, true);

      this.formRegistration.patchValue({
        id: "",
        mrn: "",
        prefix: PrefixCode,
        firstName: firstName,
        lastName: lastName,
        fullName: firstName + " " + lastName,
        firstNameTh: myKadData.FirstNameTh || "",
        lastNameTh: myKadData.LastNameTh || "",
        primaryId: IdType,
        expiryDate: myKadData.ExpiryDate
          ? new Date(moment(myKadData.ExpiryDate, "DD/MM/YYYY").toDate())
          : "",
        primaryNumber: myKadData.ICNo,
        dateOfBirth: new Date(dob),
        gender: GenderCode,
        addressPrimary: [myKadData.Address1, myKadData.Address2, myKadData.Address3].filter(Boolean).join(" "),
        countryPrimary: CountryCode,
        cityPrimary: "",
        statePrimary: "",
        subDistrictPrimary: "",
        pincodePrimary: myKadData.Postcode
      });

      
      if (myKadData?.State) {
        setTimeout(() => {
          const StateCode = this.patientRegService.getCodeBySystemCode(
            this.statePrimaryList,
            myKadData.State ? myKadData.State : ""
          );

          this.stateValue = StateCode;
          this.formRegistration.patchValue({ statePrimary: StateCode });

          const State = this.patientRegService.getObjByCode(
            this.statePrimaryList,
            StateCode
          );
          this.getCityPrimaryList(State);

          setTimeout(() => {
            const CityCode = this.patientRegService.getCodeBySystemCode(
              this.cityPrimaryList,
              myKadData.City ? myKadData.City : ""
            );

            this.cityValue = CityCode;
            this.formRegistration.patchValue({ cityPrimary: CityCode });

            const City = this.patientRegService.getObjByCode(
              this.cityPrimaryList,
              CityCode
            );
            this.getSubDistrictPrimaryList(City);

            setTimeout(() => {
              const SubDistrictCode = this.patientRegService.getCodeBySystemCode(
                this.subDistrictPrimaryList,
                myKadData.SubDistrict ? myKadData.SubDistrict : ""
              );

              this.districtValue = SubDistrictCode;
              this.formRegistration.patchValue({ 
                subDistrictPrimary: SubDistrictCode,
                pincodePrimary: this.postCodeValue
              });
            }, 1500);
          }, 1500);
        }, 1500);
      }

      if (myKadData.PhotoBase64)
        this.patientImage = "data:image/jpeg;base64," + myKadData.PhotoBase64;
      else this.patientImage = "";

      this.primaryNumberOnKeyUp(myKadData.ICNo, 0, false);
      this.formRegistration.updateValueAndValidity();
      this.checkDuplicatePatient('identificationNo', this.identificationList.data[0]);
    }
  }

  /**
   *
   *
   * @memberof EmergencyRegistrationComponent
   */
  getMyKadMasters() {
    this.getIdentificationTypeMaster();
    this.getGenderMaster();
  }

  /**
   *
   *
   * @memberof EmergencyRegistrationComponent
   */
  getGenderMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_GENDER,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.genderList = data;
      });
  }

  /**
   *
   *
   * @memberof EmergencyRegistrationComponent
   */
  getIdentificationTypeMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.identificationTypeList = data;
      });
  }

  secondaryDistrictAreaSelected(event) {
    if (event.postCode)
      this.formNextOfKin.patchValue({
        postcode: event.postCode,
      });
  }

  /**
   * get speciality
   * @param event 
   */
  getSpeciality(value){
    if(value){
      this.masterApiService
        .postTypeMaster(OPD_API_URL.GET_SPECIALITY_BY_DOCTOR+value, '')
        .pipe(takeUntil(this._onDestroy))
        .subscribe((data: any) => {
          if(data.payload){
            // this.departmentFilterLists =data.payload;
            // this.departmentValues= data.payload[0];
            this.departmentValues = this.departmentFilterLists.find((element) => element.code === data.payload[0].code);
          }
        })
    }

  }

  /**
   *Search On changes
   *
   * @memberof SamplePatientRegistrationComponent
   */
  searchOnChanges() {
    this.subscriptionList.add(
      this.doctorSearch.valueChanges.subscribe((value) => {
        const searchValue = (value || '').toString().toLowerCase();
        this.doctorFilteredList = this.docList.filter((i) =>
          i.desc.toString().toLowerCase().includes(searchValue) ||
          i.code.toString().toLowerCase().includes(searchValue)
        );
      })
    );
    this.subscriptionList.add(
      this.formRegistration.controls["dateOfBirth"].valueChanges.subscribe(
        (val) => {
          this.patientAge = this.patientService.calculateAge(val,"formatted");
        }
      )
    );
    this.subscriptionList.add(
      this.dipartmentSearch.valueChanges.subscribe((value) => {
        this.departmentFilterLists = this.departmentLists.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.formEncounter.controls["visitToDepartment"].valueChanges.subscribe(
        (isVisitToDepartment) => {
          let doctorControl = this.formEncounter.controls["doctor"];
          this.formEncounter.controls["doctor"].setValue("");
          if (isVisitToDepartment) {
            doctorControl.clearValidators();
            this.isDepartment = false;
            doctorControl.disable();

          } else {
            doctorControl.enable();
            doctorControl.setValidators([Validators.required]);
            this.isDepartment = true;
          }
          doctorControl.updateValueAndValidity();
        }
      )
    );
    this.subscriptionList.add(
      this.payerTypeSearch.valueChanges.subscribe((value) => {
        this.payerTypeList = this.payerTypeFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.payerSearch.valueChanges.subscribe((value) => {
        this.dataSourcePayers.data.forEach((element, index) => {
        element.payerList = element.payerFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    })
    );
    this.subscriptionList.add(
      this.contractCodeSearch.valueChanges.subscribe((value) => {
        this.dataSourcePayers.data.forEach((element, index) => {
          element.contractList = element.contractCodeList.filter((i) =>
            i.desc.toString().toLowerCase().includes(value.toLowerCase())
          );
        });
      })
    );
    this.subscriptionList.add(
      this.associatedCompanySearch.valueChanges.subscribe((value) => {
        this.associatedCompanyList = this.associatedCompanyCodeList.filter(
          (i) => i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.tariffSearch.valueChanges.subscribe((value) => {
        this.tariffList = this.tariffFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.countrySearch.valueChanges.subscribe((value) => {
        this.countryPrimaryList = this.countryList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.primaryIdSearch.valueChanges.subscribe((value) => {
        this.primaryIdFilteredList = this.primaryIdList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
     this.subscriptionList.add(
      this.secondaryIdSearch.valueChanges.subscribe((value) => {
        this.secondaryIdFilteredList = this.secondaryIdList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );

    this.subscriptionList.add(
      this.formNextOfKin.controls["country"].valueChanges.subscribe((val) => {
        this.getNOKStateList(val);
      })
    );

    this.subscriptionList.add(
      this.formNextOfKin.controls["state"].valueChanges.subscribe((val) => {
        this.getNOKCityList(val);
      })
    );
    this.subscriptionList.add(
      this.formNextOfKin.controls["city"].valueChanges.subscribe((val) => {
        this.getSubDistrictForNOK(val);
      })
    );
    this.subscriptionList.add(
      this.primaryIdSearchNok.valueChanges.subscribe((value) => {
        this.primaryIdFilteredListNok = this.primaryIdListNOK.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
     this.formRegistration.get('prefix')?.valueChanges.subscribe(prefixValue => {
      if (prefixValue ===  "null") {
        this.formRegistration.controls["prefix"].setValue(null);
        this.formRegistration.controls["gender"].enable();
        this.formRegistration.controls["gender"].setValue(null);
        this.genderValue = null;
      }
    });
  }

  
   /**
   *validate doctor
   *
   * @memberof EmergencyRegistrationComponent
   */
   validationOnDoctor() {
    
    let departmentCode = this.formEncounter.controls["department"].value;
    let doctorCode = this.formEncounter.controls["doctor"].value;
    if (this.patientId && departmentCode) {
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_DUPLICATE_ENCOUNTER +
            departmentCode.code +
            "&doctorCode=" +
            doctorCode +
            "&patientId=" +
            this.patientId
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((response: any) => {
          if (response) {
            this.snackBar.open(
              this.langService.get("CommonAppoinment.warning"),
              this.langService.get("CommonAppoinment.duplicateEncouter") + "",
              {
                duration: 1000,
              }
            );
          }
        });
    }
  }


  /**
   *upload image
   *
   * @memberof SamplePatientRegistrationComponent
   */
  uploadImageDialog(): void {
    const dialogRef = this.dialog.open(CameraDialogComponent, {
      width: "400px",
      data: { name: "" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        try {
          if (result.res == "yes") {
            this.patientImage = result.picdata;
          } else {
            this.patientImage = "";
          }
        } catch (e) {}
      })
    );
  }
  /**
   *select patient Data
   *
   * @param {*} patient
   * @memberof SamplePatientRe
   * 
   * gistrationComponent
   */
  patientOnSelect(patient) {
    this.isSelectedPatient=true;
    this.getPatientStatus(patient);
  }
  getPatientStatus(patient) {
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.PATIENT_STATUS_FILTER + patient.id)
      .subscribe((res) => {
        this.admissionStatus = res.isAdmitted;
        if (res.isAdmitted == true) {
          
          if (res.validationMsg) {
            this.snackBar.open(
            this.langService.get("adt.Selectedpatient"),
            this.langService.get("dialogs.info"),
            {
              duration: 3000,
            });
          }
           this.formRegistration.reset();
           this.formEncounter.reset();
        } else {
          if (patient.id) {
            this.formRegistration.get('isKnown').setValue(false);
            this.getPatientData(patient);            
            this.isRegistered = true;
            // this.isDisabledName = true;
            this.isDisabledName = false;
          }
        }
      });
  }

  /**
   *get patient data
   *
   * @param {*} patient
   * @memberof PatientRegistrationComponent
   */
  getPatientData(patient) {
    this.identificationList=new MatTableDataSource<Identification>([]); 
    if (patient.ctos || patient.blocked || patient.deceased || patient.merged || patient.isInactive|| patient?.isVerified===false ||patient.haveConditionType) {

      
         const reasons: string[] = [];
        if (patient.deceased) {
          reasons.push("<div class='div'><div><span class='material-icons blocked-icon'>heart_broken</span></div><div>"+this.langService.get("EncounterPage.unabletoProceedDecease")+"</div></div>");
        }
        if (patient.merged) {
          reasons.push("<div class='div'>" +"<div><span class='material-icons blocked-icon'>call_merge</span></div>" + "<div>" + this.langService.get('RegistrationPage.mrn') + " " +
           patient.mrn + this.langService.get('EncounterPage.mergeMes') + patient.mergedPatient +this.langService.get('EncounterPage.mergeMes1') +"</div>" + "</div>");
        }

        if (patient.blocked) {
          reasons.push("<div class='div'><div><span class='material-icons blocked-icon'>person_off</span> </div><div>"+this.langService.get("EncounterPage.selectPatientBlock")+"</div></div>");
        }

        if (patient.isInactive) {
          reasons.push("<div class='div'><div><span class='material-icons blocked-icon'>pause_circle</span></div><div>"+this.langService.get("EncounterPage.selectPatientInactive")+"</div></div>");
        }

        if (patient?.isVerified===false) {
          reasons.push("<div class='div'><div><span class='material-icons blocked-icon'>swap_horiz</span></div><div>"+this.langService.get("EncounterPage.migratedRecordMessage")+"</div></div>");
        }

        if (patient.ctos) {
          reasons.push("<div class='div'><div><span class='material-icons blocked-icon'>receipt_long</span></div><div>"+this.langService.get("EncounterPage.info")+"</div></div>");
        }
        if (patient.haveConditionType) {
           reasons.push(
            "<div class='div'><div><span class='material-icons blocked-icon'>warning</span></div>" +
            "<div>"+this.langService.get("EncounterPage.criticalPatientMeg")+"</div></div>"
          );
        }

        if (!reasons.length) {
          return;
        }
        const formatReasons = (items: string[]) => {
          if (items.length === 1) return items[0];
          if (items.length === 2) return items.join(' <br>');
          return items.slice(0, -1).join(', <br>') + ' <br> '+items[items.length - 1];
        };

        const finalMessage =  formatReasons(reasons);
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: "30%",
        data: {
          display:!patient.isVerified?"Info":
            patient.mrn +
            " / " +
            (patient.patientNameLangBase || patient.fullName) +
            " / " +
            (patient.gender ? patient.gender : "Unknown") +
            " / " +
            (patient.dateOfBirth ? patient.dateOfBirth : ""),
          info:finalMessage,
        },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (
            result != undefined &&
            result.confirm &&
            result.confirm == "yes"
          ) {
            if(!patient.isVerified){
              let patientValue: any = {};
              patientValue.mrn=patient.mrn;
              patientValue.isFromQuickReg=true;
              localStorage.setItem(
                "QuickReg",
                JSON.stringify(patientValue)
              );
               this.router.navigate(['OPD/patient/patient-encounter']);
              }
            this.clearAllPatientEncounter();
          } else { this.clearAllPatientEncounter(); 

          }
        })
      );
    } else {
      this.isVip = patient.vip;
      this.isVip == true ?  this.isDisabled = true : this.isDisabled = false;
      this.isNoteVisible = patient.patientNotes ? patient.patientNotes :"";
      this.getPreviousEncounters(patient.mrn);
      this.selectedPatient = patient;
      this.patientCategoryValue = this.selectedPatient.patientCategory? this.selectedPatient.patientCategory : ""; 
      this.selectedPrimaryId = this.selectedPatient
                 ? this.selectedPatient.idNo
                 : "";
      this.genderValue = this.selectedPatient
        ? this.selectedPatient.gender
        : "";
      this.identifierTypeValue = this.selectedPatient
        ? this.selectedPatient.identifierType
        : "";
      this.titleValue = this.selectedPatient ? this.selectedPatient.title : "";
      this.countryValue = this.selectedPatient
        ? this.selectedPatient.extendedAddress
          ? this.selectedPatient.extendedAddress.country
          : null
        : null;
      // this.getDocuments(patient.mrn);
      this.getPreviousPayerList(patient.mrn);
      var dobFormatted = "";
      var patientAge = undefined;
      if (patient.dateOfBirth) {
        dobFormatted = patient.dateOfBirth
        ? (this.langaugeValue== Langauge.TH
          ? this.thConvertService.convertThaiDateString(patient.dateOfBirth)
          : this.datepipe.transform(patient.dateOfBirth, "dd-MM-yyyy"))
        : null;
        let dobDate = new Date(patient.dateOfBirth);
        patientAge = this.utilsService.getAge(dobDate);
        patientAge =
          patientAge > 1
            ? "(" + patientAge + " Years)"
            : "(" + patientAge + " Year)";
      }
      this.patientInfoDisplay =
        patient.mrn +
        " / " +
      (this.showPatientPrefix && patient.displayTitle
        ? patient.displayTitle + " "
        : "") + (patient.patientNameLangBase || patient.fullName) + 
        " / " +
        (patient.gender ? patient.gender : "Unknown") +
        " / " +
        (patient.dateOfBirth ? dobFormatted + " " + patientAge : "");

      this.patientImage = patient.photo ? patient.photo.url : "";
      this.formRegistration.enable();
      this.patientId = patient.id;
      this.formEncounter.controls["visittype"].setValue("ER");
    
      if (patient.patientNotes)
        this.formEncounter.controls["reportRemarks"].setValue(
          patient.patientNotes
        );        
        if (patient.identifierType=="Passport") {
          this.formRegistration.controls["expiryDate"].enable();
          this.isexpiryDate = true;
        } else {
          this.formRegistration.controls["expiryDate"].setValue("");
          this.formRegistration.controls["expiryDate"].disable();
          this.isexpiryDate = false;
        }   
        this.countryCode= this.selectedPatient.countryCode;
       let countrycodeObj = this.countryCodeLists.find(
        (code) => code.code === this.countryCode
      );
      this.setPatternToMobileNumber(countrycodeObj);

      this.isPrimaryNoEditable=patient.identifierType?true:false;
      this.formRegistration.patchValue({
        id: patient.id,
        mrn: patient.mrn,
        primaryNumber: patient.idNo,
        primaryId: patient.identifierType ? patient.identifierType : "",
        expiryDate: patient.expiryDate ? new Date(patient.expiryDate) : "",
        issuedCountryPrimary: patient.idIssueCountry
          ? patient.idIssueCountry
          : "",
        issuedCountrySecondary: "",
        fullName: patient.fullName,
        // aliasName: patient.aliasName ? patient.aliasName : "",

        dateOfBirth: patient.dateOfBirth ? new Date(patient.dateOfBirth) : "",
        birthTime: patient.birthTime ? patient.birthTime : "",
        realdob: patient.real ? patient.real : false,
        birthplace: patient.birthlocation ? patient.birthlocation : "",
        motherName: patient.motherName ? patient.motherName : "",
        patientNotes: patient.patientNotes ? patient.patientNotes : "",
        
        doctor:patient.doctor ?patient.doctor:"",
        department:patient.department? patient.department:"",
        
        clinic:patient.clinic ? patient.clinic:"",

        addressPrimary: patient.extendedAddress
          ? patient.extendedAddress.addressLine
          : "",

        cityPrimary:
          patient.extendedAddress && patient.extendedAddress.city
            ? patient.extendedAddress.city
            : "",
        subDistrictPrimary:
          patient.extendedAddress && patient.extendedAddress.area
            ? patient.extendedAddress.area
            : "",
        pincodePrimary: patient.extendedAddress
          ? patient.extendedAddress.postCode
          : "",
        emailId: patient.emailId,
        homeContact: patient.homeContactNo,
        mobileNumber: patient.mobileNumber,
        addressSecondary: patient.correspondingAddress
          ? patient.correspondingAddress.addressLine
          : "",

        pincodeSecondary: patient.correspondingAddress
          ? patient.correspondingAddress.postCode
          : "",
        workContact: patient.workContactNo,
        contactRelation: patient.relation ? patient.relation : "",
        isDeceased: patient.deceased ? patient.deceased : "",
        isBlocked: patient.blocked ? patient.blocked : "",
        isVip: patient.vip ? patient.vip : false,
        isNewborn: patient.newBorn ? patient.newBorn : false,
        workFax: patient.workFax ? patient.workFax : "",
        personalFax: patient.personalFax ? patient.personalFax : "",
        secondaryExpirydate: patient.seondaryExpiryDate
          ? new Date(patient.seondaryExpiryDate)
          : "",
        firstName: patient.firstName ? patient.firstName : "",
        middleName: patient.middleName ? patient.middleName : "",
        lastName: patient.lastName ? patient.lastName : "",
        firstNameTh: patient.firstNameTh ? patient.firstNameTh : "",
        middleNameTh: patient.middleNameTh ? patient.middleNameTh : "",
        lastNameTh: patient.lastNameTh ? patient.lastNameTh : "",
      });
      this.getNOKList();
    //   if(patient.identifierType != ""){
    //   let primaryIdValue = this.primaryIdFilteredList.find(e=>e.desc==patient.identifierType);
    //   if(primaryIdValue.isMyKad) this.primaryNumberOnKeyUp(patient.idNo);
    // }
     if (patient.primaryIdentificationList.length>0 || patient.secondaryIdentificationList.length>0) {
              const tempData: any[] = [];
              // Handle Primary Identification
              patient.primaryIdentificationList?.forEach((element) => {
                const idTypeCode = this.getObjByCode(this.primaryIdFilteredList, element.code);
                const data = {
                  identifierUUID: element.identifierUUID || '',
                  type: 'P',
                  idType: element.code,
                  idNumber: element.value?element.value:"",
                  expDate: element.expiryDate,
                  primaryIdRegex: OPD_CONST.primaryIdRegix,
                  isExpiryRequired: element.display === "Passport",
                  issuingCountry: element.issuingCountryCode || '',
                  isCopied: element.status === false,
                  isIdNumberValid:element.value?.length>0?true:false,
                  isCountryRequired:false
                };
            
                if (element.status) {
                  this.identificationList.data.push(data);
                  const newIndex = this.identificationList.data.length - 1;
                  this.primaryIdentificationOnChange(idTypeCode, false, newIndex);
                } else {
                  tempData.unshift(data); 
                }
              });
            
              // Handle Secondary Identification
              patient.secondaryIdentificationList?.forEach((element) => {
                if (element.status) {
                  const data = {
                    identifierUUID: element.identifierUUID || '',
                    type: 'S',
                    idType: element.code,
                    idNumber: element.value?element.value:"",
                    expDate: element.expiryDate,
                    issuingCountry: element.issuingCountryCode || '',
                    primaryIdRegex: OPD_CONST.primaryIdRegix,
                    isExpiryRequired: false,
                    isIdNumberValid:element.value?.length>0?true:false,
                    isCountryRequired:false
                  };
                  this.identificationList.data.push(data);
                }
              });
            
              const sorted = this.identificationList.data
                .filter(d => !d.isCopied)
                .concat(tempData);
              this.identificationList.data = [...sorted];
            
            } else {
              this.addEmptyIdentificationEntry("P");
            }
            
            this.selectedPatientIdentificationList = JSON.parse(JSON.stringify(this.identificationList.data));
    

    this.getStatePrimaryList(
      patient.correspondingAddress && patient.correspondingAddress.country != ""
        ? patient.correspondingAddress.country
        : patient.extendedAddress.country,
      true
    );
      if (
        patient.extendedAddress.addressLine ==
          patient.correspondingAddress.addressLine &&
        patient.extendedAddress.postCode ==
          patient.correspondingAddress.postCode
      ) {
        this.isBothAddressSame = true;
      }
    }
  }

  /**
   *temporary patient details
   *
   * @param {string} trnNumber
   * @memberof PatientRegistrationComponent
   */
  getTemporaryPatient(trnNumber: string) {
    this.patientForm = true;
    this.patientTRN = trnNumber;

    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_TEMP_PATIENT_SEARCH + trnNumber
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        if (res) {
          this.patientInfoDisplay = "";
          this.patientInfoDisplay =
            res.trn +
            " / " +
            res.patientName +
            " / " +
            (res.genderList ? res.genderList[0].display : "Unknown");
          this.selectedPatient = null;
          (this.identifierTypeValue = res.primaryIdentificationType
            ? res.primaryIdentificationType[0].code
            : ""),
            (this.titleValue = res.prefixList ? res.prefixList[0].code : ""),
            (this.genderValue = res.genderList ? res.genderList[0].code : ""),
            this.formRegistration.patchValue({
              prefix: res.prefixList ? res.prefixList[0].code : "",
              emailId: res.email,
              // firstName: res.patientName,
              fullName: res.fullName ? res.fullName : (res.patientName ? res.patientName : ""),
            firstName: res.firstName?res.firstName:"",
            middleName:res.middleName?res.middleName:"",
            lastName:res.lastName?res.lastName:"",
            firstNameTh:res.mfirstName?res.mfirstName:"",
            middleNameTh:res.middleName?res.middleName:"",
            lastNameTh : res.mlastName?res.mlastName:"",
              dateOfBirth: res.dob,
              mobileNumber: res.mobileNo,
              homeContact: res.homeNo,
              workContact: res.officeNo,
              primaryNumber: res.idNumber,
              expiryDate: res.idExpiry ? new Date(res.idExpiry) : "",
              addressPrimary: res.extendedAddress
                ? res.extendedAddress.addressLine
                : "",

              countryPrimary:
                res.extendedAddress && res.extendedAddress.countryList
                  ? res.extendedAddress.countryList[0].code
                  : "",
              statePrimary:
                res.extendedAddress && res.extendedAddress.stateList
                  ? res.extendedAddress.stateList[0].code
                  : "",
              cityPrimary:
                res.extendedAddress && res.extendedAddress.cityList
                  ? res.extendedAddress.cityList[0].code
                  : "",
              subDistrictPrimary:
                res.extendedAddress && res.extendedAddress.areaList
                  ? res.extendedAddress.areaList[0].code
                  : "",
              pincodePrimary: res.extendedAddress
                ? res.extendedAddress.postCode
                : "",
            });
        }
      });
  }

  /**
   *get documents using MRN
   *
   * @param {*} mrn
   * @memberof SamplePatientRegistrationComponent
   */
  // getDocuments(mrn) {
  //   this.fileUploadRegList = [];
  //   this.appBaseService.setResourceURL(OPD_API_URL.FILE_SERVICE);
  //   this.appBaseService
  //     .getFileResource(OPD_API_URL.OPD_FILE_GET + "?mrn=" + mrn)
  //     .pipe(takeUntil(this._onDestroy))
  //     .subscribe((res) => {
  //       if (res.payload) {
  //         res.payload.forEach((element) => {
  //           if (element.visitNo == null || element.visitNo == "") {
  //             let docType = this.docTypeFilteredList.find((data) => {
  //               return data.code == element.documentTypeMaster.code;
  //             });
  //             this.fileUploadRegList.push({
  //               id: element.id,
  //               fileType: docType.code,
  //               fileName: element.fileName,
  //               files: element.data,
  //               fileDescription: element.fileDescription,
  //               mrn: element.mrn,
  //               isUploaded: true,
  //             });
  //           }
  //         });
  //       }

  //       this.fileSourceReg = new MatTableDataSource(this.fileUploadRegList);
  //     });
  // }

  /**
   *get previous encounters data
   *
   * @param {*} patientMrn
   * @memberof SamplePatientRegistrationComponent
   */
  getPreviousEncounters(patientMrn) {
    let list = [];
    // this.formEncounter.reset();
    let reqPayload = patientMrn + OPD_API_URL.OPD_PREVIOUS_ENCOUNTERS;

    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_ENCOUNTER_LIST + reqPayload
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        if (res && res.totalRecords > 0) {
          res.response.forEach((element, index) => {
            this.patientImage = element.patient
              ? element.patient[0]
                ? element.patient[0].photo[0].url
                : ""
              : "";
            var utcSeconds = element.createdDate;
            var encounterDate = new Date(0);
            this.previousInternalNotes = element.encounterNote;
            this.internotesEncounterNo = element.encounterNumber;
            this.internotesEncounterid = element.id;
            list.push({
              EncounterId: element.id,
              VisitDate: utcSeconds
                ? (this.langaugeValue== Langauge.TH
                  ? this.thConvertService.convertToThaiDate(utcSeconds) :  this.datepipe.transform(utcSeconds*1000, "dd/MM/yyy hh:mm aa")): null,
              VisitNumber: element.encounterNumber,
              visitType: element.visitType ? element.visitType.display : "",
              Department: element.department ? element.department.display : "",
              DoctorName: element.doctor ? element.doctor.display : "",
              OutstandingAmount: "0.00",
              BillNumber: "",
              payer:element.payer ? element.payer :"",
  
              BillAmount: element.billAmount ? element.billAmount : "0.00",
            });
            if (index == res.totalRecords - 1) {
              this.encounterTypeValue = element.encounterType
                ? element.encounterType.code
                : "";
              // this.departmentValues = element.department
              //   ? element.department.code
              //   : "";
              this.doctorValue = element.doctor ? element.doctor.code : "";
            }
          });
        }
        this.previousEncounterList = list;
        this.dataSourceEncounters =
          new MatTableDataSource<priviousEncounterObject>(list);
      });
  }

  /**
   *get list data by code
   *
   * @param {any[]} list
   * @param {string} code
   * @return {*}  {string}
   * @memberof SamplePatientRegistrationComponent
   */
  getObjByCode(list: any[], code: string): string {
    let value;
    if (list && list.length > 0) {
      value = list.find((i) => i.code == code);
    }
    return value;
  }

  /**
   *confirm window
   *
   * @memberof SamplePatientRegistrationComponent
   */
  confirmClearPatientEncounter() {
    const dialogRefConfirm = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { confirm: "no" },
    });
    this.subscriptionList.add(
      dialogRefConfirm.afterClosed().subscribe((result) => {
        if (result.confirm == "yes") {
          this.clearAllPatientEncounter();
        }
      })
    );
  }

  /**
   *validate registration
   *
   * @return {*}  {boolean}
   * @memberof SamplePatientRegistrationComponent
   */

  validateRegistration(): boolean {
    if (this.isDeceased) {
      return this.formRegistration.valid;
    } else{
      if(!this.formRegistration.controls["mobileNumber"].valid){
        this.formRegistration.controls["mobileNumber"].markAsTouched();
        this.snackBar.open(
        this.langService.get("CommonAppoinment.addDependend"),
          this.langService.get("CommonAppoinment.validation"),
        {duration:1000}
        );
        return this.formRegistration.valid;
    } else {
      for (var i in this.formRegistration.controls) {
        this.formRegistration.controls[i].markAsTouched();
      }
      if (!this.formRegistration.valid) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.pleasefillallmandatory"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 1000,
          }
        );
      }
      return this.formRegistration.valid;
    }
  }
  }

  /**
   *Validation encounter
   *
   * @return {*}  {boolean}
   * @memberof SamplePatientRegistrationComponent
   */
  validateEncounter(): boolean {
    let valid = true;
    let payersList = this.dataSourcePayers.data;
    if (payersList.length > 0) {
      payersList.forEach((element) => {
        if (element.payerCode == "" || element.payerCode == undefined) {
          valid = false;
          this.snackBar.open(
            this.langService.get("EncounterPage.pleaseselectreferrconpamy"),
            this.langService.get("CommonAppoinment.validation"),
            {
              duration: 3000,
            }
          );
        }
      });
    }
    if (payersList.length > 0) {
      payersList.forEach((element) => {
        if (element.tariffCode == "" || element.tariffCode == undefined) {
          valid = false;
          this.snackBar.open(
            this.langService.get("CommonAppoinment.PleaseSelectTariff"),
            this.langService.get("CommonAppoinment.validation"),
            {
              duration: 1000,
            }
          );
        }
      });
    }
    if (valid) {
      for (var i in this.formEncounter.controls) {
        this.formEncounter.controls[i].markAsTouched();
      }
      valid = this.formEncounter.valid;

      if (!valid) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.pleasefillallmandatory"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 1000,
          }
        );
      }
    } 
       if (this.mandatoryField.identificationType || this.mandatoryField.identificationNo) {
       for (const element of this.identificationList.data) {
         if (element.type === "P" && (!element.idType || !element.idNumber.replace(/-/g, '') || !element.isIdNumberValid) ||
           (element.isExpiryRequired && !element.expDate) ||
           (element.isCountryRequired && !element.issuingCountry)) {
           this.snackBar.open("Please check Primary Identification Details", "Validation", { duration: 2000 });
           return false;
         }else if(element.type!=="P" && this.identificationList.data.length==1){
          this.snackBar.open("Please Add Primary Identification Details", "Validation", { duration: 2000 });
           return false;
         }
       }
     }
    if (this.mandatoryField.secIdentificationType || this.mandatoryField.secIdentificationNo) {
      for (const element of this.identificationList.data) {
        if (element.type === "S" && (!element.idType || !element.idNumber.replace(/-/g, '') || !element.isIdNumberValid)||
           (element.isExpiryRequired && !element.expDate) ||
           (element.isCountryRequired && !element.issuingCountry)) {
          this.snackBar.open("Please check Secondary Identification Details", "Validation", { duration: 2000 });
          return false; 
        }
      }
    }
      if (this.kinData.length == 0 && this.isNOKRequired) {
      valid = false;
      this.snackBar.open(
        this.langService.get("Please Add  Next of Kin (Dependent) Details"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    }
     let isGuarantorMissing = this.kinData.every(kin => !kin.isGuarantor);

    if (isGuarantorMissing && this.isNOKRequired) {
      valid = false;
      this.snackBar.open(
        this.langService.get("Please select at least one guarantor."),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    }
    return valid;
  }

  /**
   *patient search
   *
   * @memberof PatientRegistrationComponent
   */
  public initSearchFilter() {
    this.subscriptionList.add(
      this.searchHead
        .getTypeSearch(OPD_API_URL.M_PAT_REG_SEARCH)
        .subscribe((data: any) => {
          this.searchHead.updateSearchHeader(data);
        })
    );

    this.subscriptionList.add(
      this.searchService.getResult.subscribe((result) => {
        this.searchCriteria = this.searchHead.SetPatientSearch(result);
        this.patientList = null;
        this.refreshTime = new Date().toString();
        this.hidePatientSearch = false;
      })
    );
    let quickSearch = this.searchService.getElasticSearch.subscribe(
      (quickSearch) => {
        let result = { mrn: quickSearch };
        this.searchCriteria = this.searchHead.SetPatientSearch(result);
        this.patientList = null;
        this.refreshTime = new Date().toString();
        this.hidePatientSearch = false;
      }
    );
    this.subscriptionList.add(quickSearch);
  }

  /**
   *save encounter
   *
   * @memberof SamplePatientRegistrationComponent
   */
   saveEncouter() {
    if (this.validateRegistration() && this.validateEncounter()) {
      if(this.formRegistration.controls["isVip"].value) {
        const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "15%",
          data: { displayText: "conformVipMessage"},
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result && result.confirm == "yes") {
              this.openRegisterConfirmationDialog();
            }
          })
        );
      } else {
        this.openRegisterConfirmationDialog();
      } 
    }
 }

  openRegisterConfirmationDialog(): void {
    const dialogRef = this.dialog.open(RegsuccessDialogComponent, {
      width: "20%",
      data: {},
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.workflow == "yes") {
          this.openEncounterConfirmDialog();
        }
      })
    );
  }

  /**
   *save patient and encounter
   *
   * @memberof SamplePatientRegistrationComponent
   */
  openEncounterConfirmDialog() {
     let patient:PatientRegistration=
    this.patientRegService.getRegistrationFormValues(
      this,
      this.formRegistration
    );
    let encounter = this.patientRegService.getEncounterFormValues(
      this,
      this.formEncounter
    );
    encounter.defaultDeposit = this.defaultDeposit;
     let dataSourcePayers = this.patientRegService.getEncounterPayerFormValues(
      this,
      this.dataSourcePayers
    );
   
    let requestPatientPayload = this.patientRegService.setSavePayload(
      this,
      patient
    );
    let requestEncounterPayload = this.patientRegService.setEncounterSave(
      this,
      encounter,
      dataSourcePayers,
      this.dataSourceNextOfKin.data
    );

    let requestObject = {
      patientRequest: requestPatientPayload,
      encounterRequest: requestEncounterPayload,
      unitName:this.unitName?this.unitName:"",
      orgName:this.orgName?this.orgName:"",
    };
    this.subscriptionList.add(
      this.generalApiService
        .postTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.S_EMERGENCY_REGISTRATION,
          requestObject
        )
        .subscribe((response: any) => {
          if (response && response.id) {
            let encounterNumber = response.encounterNumber
              ? response.encounterNumber
              : response.identifier[0]
              ? response.identifier[0].value
              : "";

            this.snackBar.open(
              this.langService.get("EncounterPage.encounterHeader") +
                ": " +
                encounterNumber +
                " " +
                this.langService.get("EncounterPage.patientSaved"),
              this.langService.get("CommonAppoinment.success"),
              {
                duration: 1000,
              }
            );

            this.encounternumber = response.encounterNumber;
            this.previousInternalNotes = [];
            this.internalNotesList = [];
            // this.printPayload = {
            //   transactionId: response.id,
            //   type: OPD_REPORT_TYPE.pdf,
            //   reportName: OPD_REPORT_NAME.encounter_Slip,
            //   isReports: false,
            // };
            // localStorage.setItem(
            //   OPD_CONST.reportPayload,
            //   JSON.stringify(this.printPayload)
            // );
            // window.open(opdNavigation.REPORT_NAVIGATE);
            // const secondPrintPayload = {
            //   transactionId: response.id,
            //   type: OPD_REPORT_TYPE.pdf,
            //   reportName: OPD_REPORT_NAME.asmission_Label, 
            //   parameterList: [{
            //     parameter: "isPrefixRequired",
            //     value: false
            //   }],
            //   isOPD: true
            // };
            // localStorage.setItem(
            //   OPD_CONST.reportPayload2,
            //   JSON.stringify(secondPrintPayload)
            // );
            // window.open(opdNavigation.REPORT_NAVIGATE );
            this.patientLableService.generateReports(response.id,OPD_REPORT_NAME.asmission_Label);
            this.encounterSlipService.generateReports(response.id,OPD_REPORT_NAME.encounter_Slip);
            if(this.isPDPAReport){
              this.pdpaFormService.generateReports( response.id,OPD_REPORT_NAME.pdpaForm_new);
            }
            this.clearAllPatientEncounter();
            this.router.navigate(['OPD/erRegistration/erRegistrationList']);
          }
        })
    );
  }

  /**
   *mobile format
   *
   * @param {string} value
   * @param {string} name
   * @memberof SamplePatientRegistrationComponent
   */
  // mobileFormat(value: string, name: string) {
  //   var r = /(\D+)/g,
  //     npa = "",
  //     last4 = "";
  //   value = value.replace(r, "");
  //   npa = value.substr(0, 3);
  //   last4 = value.substr(3, 10);
  //   value = npa + "-" + last4;
  //   if (value.replace("-", "").trim() == "") value = "";
  //   if (name == "mobile") {
  //     this.formRegistration.controls.mobileNumber.setValue(value);
  //   }
  // }

  /**
   *clear allthe data
   *
   * @memberof SamplePatientRegistrationComponent
   */
  clearAllPatientEncounter() {
    localStorage.removeItem("appointmentData");
    localStorage.removeItem("admissionRequest");
    this.previousInternalNotes = [];
    this.internalNotesList = [];
    this.patientId = "";
    this.patientImage='';
    this.selectedPatient = {};
    this.isSelectedPatient=false;
    this.patientInfoDisplay='';
    this.defaultDeposit = "";
    this.patientCategoryValue = "";
    this.formRegistration.reset();
    this.formEncounter.reset();
    this.formRegistration.enable();
    this.formRegistration.controls["expiryDate"].setValue("");
    this.formRegistration.controls["expiryDate"].disable();

    let patientEncounterPayer = new PatientEncounterPayer();
    patientEncounterPayer.isSelf = true;
    this.dataSourcePayers = new MatTableDataSource<any>([
      patientEncounterPayer,
    ]);
    this.getFirstName()
    this.getPayerTypeList();
    this.getPayerList();
    this.fillDropDownLists();
    this.getScreenConfigurations();
    this.checkFields(false);
    this.formRegistration.get('isKnown').setValue(false);
    this.identificationList = new MatTableDataSource<Identification>([]);
    this.selectedPatientIdentificationList=[];
    this.addEmptyIdentificationEntry("P");
    this.dataSourceNextOfKin =new MatTableDataSource<any>([]);
    this.formNextOfKin.reset();
    this.cardReaderStatus = false;
  }

  /**
   *primary identification value
   *
   * @param {*} idTypeCode
   * @memberof SamplePatientRegistrationComponent
   */
  //

  primaryIdentificationOnChange(idTypeCode: any, isPrimaryNoRemove:boolean,index?) {    
     var formRegistration = this.formRegistration.controls;
     if(isPrimaryNoRemove){
     this.identificationList.data[index].idType=idTypeCode.value;
     this.identificationList.data[index].idNumber="";
     if(this.identificationList.data[index].type=='P'){
      this.mandatoryField.identificationType=true;
      this.mandatoryField.identificationNo=true;
     }
     }
     if(this.identificationList.data[index]?.type=='P'){
     if (idTypeCode?.value) {
       this.primaryIdCode = this.primaryIdFilteredList.find(
         (s) => s.code == idTypeCode.value
       );
     }else{
         this.primaryIdCode = this.primaryIdFilteredList.find(
           (s) => s.code == idTypeCode.code
         );
       }
     }else{
       if (idTypeCode?.value) {
         this.primaryIdCode = this.secondaryIdFilteredList.find(
           (s) => s.code == idTypeCode.value
         );
       }else{
           this.primaryIdCode = this.secondaryIdFilteredList.find(
             (s) => s.code == idTypeCode.code
           );
         }
     }
       // let primaryIdCode = formRegistration.primaryId.value;
       if (this.primaryIdCode) {        
         this.primaryIdNewValue=this.primaryIdCode.code?this.primaryIdCode.code:"";
         if (this.primaryIdCode.isMyKad == true) {
           formRegistration["nation"].setValue("MALAYSIAN");
           this.identificationList.data[index].primaryIdRegex = "^[0-9 -]+$";
         } else {
           this.identificationList.data[index].primaryIdRegex = this.primaryIdCode.validation
             ? this.primaryIdCode.validation
             : "";
         }
       }
       // if (!this.selectedPatient) {
        if (this.primaryIdCode) {
          const patientCategory = this.formRegistration.get('patientCategory')?.value;
          const applyForeignerRule =
            this.isForeignerExpiryMandatory &&
            patientCategory?.isIdentificationExpiryRequired === true;
          this.identificationList.data[index].isExpiryDisplayed =
            (this.primaryIdCode?.isExpireDisplayed || false) || applyForeignerRule;

          this.identificationList.data[index].isExpiryRequired =
            this.identificationList.data[index].isExpiryDisplayed &&
            ((this.primaryIdCode?.isExpireReq || false) || applyForeignerRule);
    // Clear date if hidden
       if (!this.identificationList.data[index].isExpiryDisplayed) {
       this.identificationList.data[index].expDate = "";
       }

    // ===========================
    // Expiry max date
    // ===========================

       if (this.primaryIdCode.expiryDuration) {

        const currentDate = new Date().getFullYear();

        const maxExpiryDurationDate = new Date();

        maxExpiryDurationDate.setFullYear(
          currentDate + this.primaryIdCode.expiryDuration
        );

        this.maxExpiry = maxExpiryDurationDate;

       } else {

         this.maxExpiry = new Date(
          this.year + 20,
          this.month,
          this.day
        );
      }
     }
        //  if (this.primaryIdCode?.isExpireReq) {
        //    this.identificationList.data[index].isExpiryRequired = true;
        //  } else {
        //    this.identificationList.data[index].expDate="";
        //    this.identificationList.data[index].isExpiryRequired = false;
        //  }
         this.primaryNumberOnKeyUp(this.identificationList.data[index].idNumber,index,false);
       // }
       if (this.primaryIdCode.expiryDuration) {
         const currentDate = new Date().getFullYear();
         const maxExpiryDurationDate = new Date();
         maxExpiryDurationDate.setFullYear(currentDate + this.primaryIdCode.expiryDuration);
 
         this.maxExpiry = maxExpiryDurationDate;
       }
       else{
         this.maxExpiry= new Date(this.year + 20, this.month, this.day);
       }
      if (this.primaryIdCode.validation) {
       this.identificationList.data[index].primaryIdRegex = this.primaryIdCode.validation;
        const match = this.identificationList.data[index].primaryIdRegex.match(/\{(\d+),(\d+)\}/);
        this.identificationList.data[index].minIdentificationLength = match ? parseInt(match[1], 10) : null;
        this.identificationList.data[index].maxIdentificationLength = match ? parseInt(match[2], 10) : null;
      }else{
       this.identificationList.data[index].maxIdentificationLength=25;
       this.identificationList.data[index].minIdentificationLength=0;
       this.identificationList.data[index].primaryIdRegex=OPD_CONST.primaryIdRegix;
      }
      this.formRegistration.controls["primaryNumber"].updateValueAndValidity();
      if(!this.identificationList.data[index].issuingCountry)
      this.identificationList.data[index].isCountryRequired = this.primaryIdCode ? this.primaryIdCode.isCountryRequired : false;
     
     this.primaryIdSelect(idTypeCode.value);
   }
  
  primaryIdSelect(value){
    this.isPrimaryNoEditable=value?true:false;
  }
  
  /**
   *
   *
   * @param {*} event
   * @memberof SamplePatientRegistrationComponent
   */

  editPatientClicked() {
    if (this.selectedPatient) {
      const formRegistration = this.formRegistration.controls;
      const IdTypeCode = formRegistration["IdTypeCode"].value;

      if (IdTypeCode) {
        this.isexpiryDate = IdTypeCode.isExpireReq;

        if (!this.isexpiryDate) {
          formRegistration["expiryDate"].setValue("");
          formRegistration["expiryDate"].disable();
          this.isexpiryDate = true;
        
        }else {
          formRegistration["expiryDate"].enable();
          this.isexpiryDate = false;
        }
      }
    }
  }
  /**
   *
   *
   * @param {*} prefixvalue
   * @memberof SamplePatientRegistrationComponent
   */
  getGender(prefixvalue) {
    let formRegistration = this.formRegistration.controls;
    let res =
      prefixvalue && prefixvalue.genderMaster
        ? prefixvalue.genderMaster.code
        : "";
    if (res) {
      this.genderValue = res;
      formRegistration["gender"].disable();
    } else {
      this.genderValue = this.genderValue ? this.genderValue :"" ;
      if(this.isRegistered){
        formRegistration["gender"].disable();
       }else{
        formRegistration["gender"].enable();
      }
    }
  }

  primaryNumberOnKeyUp(value: string,index?, isGenderChange?:boolean) {
    this.identificationList.data[index].idNumber=value;
    try {
      let formRegistration = this.formRegistration.controls;
      let primaryIdCode = this.identificationList.data[index].idType

      value = value.replace(/\s/g, '');
      this.identificationList.data[index].idNumber=value;
      if (primaryIdCode) {
        let primaryIdentify = this.primaryIdList.find(
          (i) => i.code == primaryIdCode
        );
        if (primaryIdentify) {
          if (primaryIdentify.isMyKad) {
            value = value.replace(/[^\d*]/g, '');
            this.identificationList.data[index].maxIdentificationLength=14;
            this.identificationList.data[index].minIdentificationLength=0;
            var r = /[^0-9*]+/g,
              npa = "",
              nxx = "",
              last4 = "";
            value = value.replace(r, "");
            var c: string = value;
            npa = value.substr(0, 6);
            nxx = value.substr(6, 2);
            last4 = value.substr(8, 4);
            value = npa + "-" + nxx + "-" + last4;
            this.identificationList.data[index].idNumber=value ? value : "";
            this.identificationList.data[index].primaryIdRegex = "^[0-9 -]+$";
          } else if (primaryIdentify.isMyKad == false) {
            this.identificationList.data[index].primaryIdRegex = "[A-Za-z0-9]*";
            this.identificationList.data[index].idNumber=value ? value : "";
          }

          if (value.length >= 12 && primaryIdentify.isMyKad) {
            const array = Array.from(c);
            const yearSuffix = parseInt(array[0] + array[1], 10);
            const cal_month = parseInt(array[2] + array[3], 10);
            const cal_day = parseInt(array[4] + array[5], 10);
            const contry = array[6] + array[7];
            const gen_val = array[11];
  
            BirthPlaceList.forEach(element => {
              if (element.birthPlaceNumber == contry) {
                this.formRegistration.patchValue({
                  birthplace: element.birthPlaceName
                });
              }
            });

            const lastDigit = Number(gen_val);
            let genderVal = lastDigit % 2 == 0 ? STATICCODESERVICE.GENDER_MASTER_FEMALE : STATICCODESERVICE.GENDER_MASTER_MALE;
            this.genderValue = (this.selectedPatient?.gender && isGenderChange==false) ? this.selectedPatient.gender : this.patientRegService.getCodeByStaticCode(this.genderList, genderVal);
  
            var currentYear = new Date().getFullYear();
            var currentYearSuffix = currentYear % 100;
  
            let yr;
            if (yearSuffix > currentYearSuffix) {
              yr = 1900 + yearSuffix;
            } else {
              yr = 2000 + yearSuffix;
            }
  
            var birthDate = new Date(yr, cal_month - 1, cal_day);
            var today = new Date();
  
            if (birthDate > today && !this.isSameDate(birthDate, today)) {
              yr -= 100;
              birthDate = new Date(yr, cal_month - 1, cal_day);
            }
            
            if (this.isValidDate(yr, cal_month, cal_day)) {
              formRegistration["dateOfBirth"].setValue(birthDate);
              formRegistration["realdob"].setValue(true);
            } else {
              this.snackBar.open(
                this.langService.get("CommonAppoinment.InvalidNRIC"),
                this.langService.get("CommonAppoinment.validation"),
                { duration: 1000 }
              );
              this.identificationList.data[index].idNumber="";
              formRegistration["birthplace"].setValue(null);
              this.genderValue = "";
              formRegistration["dateOfBirth"].setValue(null);
              formRegistration["realdob"].setValue(false);
            }
          }
        }
      }
    } catch (ex) {}
  }
  /**
   *
   *
   * @param {string} value
   * @memberof SamplePatientRegistrationComponent
   */
  onFocusOutEvent(value: any , index: number) {
    // if(value.type=="P"){
    //   this.validationOnPrimarynumber(this.identificationList.data[index]?.idNumber ,index);
    // }
    if (value.identifierUUID && this.patientId) {
      value.identifierOverride = true;
      value.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
    }
    let primaryIdCode:any = this.getObjByCode(
      this.identificationList.data[index]?.type === 'P' ? this.primaryIdFilteredList : this.secondaryIdFilteredList,
      this.identificationList.data[index]?.idType
    );
    if (primaryIdCode) {
      if (primaryIdCode.isMyKad && this.identificationList.data[index]?.idNumber.length < 14){
        this.identificationList.data[index].isIdNumberValid=false;
      } else{
        if( this.identificationList.data[index]?.idNumber.length < this.identificationList.data[index]?.minIdentificationLength){
          this.identificationList.data[index].isIdNumberValid=false;
        } else if( this.identificationList.data[index]?.idNumber.length > this.identificationList.data[index]?.maxIdentificationLength){
          this.identificationList.data[index].isIdNumberValid=false;
        } else{
          this.identificationList.data[index].isIdNumberValid=true;
        }
    }
    }
  }

  /**
   *validation primary number
   *
   * @param {string} value
   * @memberof SamplePatientRegistrationComponent
   */
  validationOnPrimarynumber(value: string , index:number) {
   let primaryIdCode = this.identificationList.data[index].idType;
      if(this.selectedPatient){
      var idNumber = this.selectedPatientIdentificationList[index].idNumber;
      }else{
         idNumber = "";
      }
      if(value!==idNumber)  {
        if (primaryIdCode && value.replace(/-/g, '')) {
        this.generalApiService
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_DUPLICATE + primaryIdCode + "&value=" + value.replace(/-/g, '')
          )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((response:any) => {
            if(response && response.status==409){
              this.identificationList.data[index].idNumber="";
            }else{
              this.identificationList.data[index].idNumber=value;
            }
          });
      }
    }
  }

  /**
   *Calcuate DOB
   *
   * @param {string} age
   * @param {string} month
   * @memberof SamplePatientRegistrationComponent
   */
  calculateDob(age: string, month: string) {
    let formRegistration = this.formRegistration.controls;

    let agecalc;
    let monthcalc;

    if (age != "0") {
      agecalc = age.split("Y", 1);
    } else {
      agecalc = 0;
    }
    if (month != "0") {
      monthcalc = month.split("M", 1);
    } else {
      monthcalc = 0;
    }
    var todayDate = new Date();
    var ageyear = todayDate.getFullYear() - Number(agecalc);
    var agemonth = todayDate.getMonth() - Number(monthcalc);
    var ageday = todayDate.getDate() - 0;
    formRegistration["dateOfBirth"].setValue(new Date(ageyear, agemonth, ageday));
  }

  /**
   *Get Payerlist
   *
   * @memberof SamplePatientRegistrationComponent
   */
  getPayerList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_COMPANY)
        .subscribe((data: any) => {
          this.payerList = data;
          this.payerFilteredList = data;
          // if(!this.selectedPatient){
          //   let res = this.payerList.find((s) => s.isSelf == true);
          //   this.dataSourcePayers.data[0].payerCode = res.code;
          // }
          // this.dataSourcePayers.data[0].payerList = []
          // this.dataSourcePayers.data[0].payerList = data;
          // this.dataSourcePayers.data[0].payerFilteredList = data;
          // this.getPayerTypeList();
        })
    );
  }

  /**
   *It is the source of payerType data.
   *
   * @memberof PatientRegistrationComponent
   */
  getPayerTypeList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_COMPANYTYPE)
        .subscribe((data: any) => {
          this.payerTypeList = data;
          this.payerTypeFilteredList = data;
          let res = this.payerTypeList.find((s) => s.isSelf  == true);
          this.dataSourcePayers.data[0].payerTypeCode = res.code;
          // this.getPayerListData(res.code, 0);
        })
    );
  }

  /**
   *It is get the tariffMaster Data
   *
   * @memberof PatientRegistrationComponent
   */
  getTariffmaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_TARIFF)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        this.tariffList = res;
        this.tariffFilteredList = res;
  
        // ✅ Bind tariff list to each row
        this.dataSourcePayers.data.forEach((payer, index) => {
          if (!payer) return;
          payer.tariffList = [...res];
          payer.tariffFilteredList = [...res];
  
          // ✅ Auto-select default tariff
          let defaultTariff = res.find((t) => t.isDefault);
          if (defaultTariff) {
            payer.tariffCode = defaultTariff.code;
            payer.isDisableTariff = true;
          }
        });
  
        // ✅ Refresh table data
        this.dataSourcePayers._updateChangeSubscription();
      });
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  // getContractListData() {
  //   this.masterApiService
  //     .getTypeMaster(OPD_API_URL.M_CONTRACT)
  //     .pipe(takeUntil(this._onDestroy))
  //     .subscribe((data: any) => {
  //       this.contractList = data;
  //       this.contractCodeList = data;
  
  //       // ✅ Bind contract list to each row
  //       this.dataSourcePayers.data.forEach((payer, index) => {
  //         if (!payer) return;
  //         payer.contractList = [...data];
  //         payer.contractCodeList = [...data];
  //       });
  
  //       // ✅ Refresh table data
  //       this.dataSourcePayers._updateChangeSubscription();
  //     });
  // }

  /**
   *It is the source of getAssociateList data.
   *
   * @memberof PatientRegistrationComponent
   */
  getAssociatedCompanyList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_ASSOCIATECOMPANY)
        .subscribe((data: any) => {
          this.associatedCompanyList = data;
          this.associatedCompanyCodeList = data;
        })
    );
  }

  /**
   *It is the source of primaryId data
   *
   * @memberof PatientRegistrationComponent
   */
  getPrimaryIdList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.identificationTypeList = data;
        this.updateIdentificationLists();
      });
  }

  private updateIdentificationLists() {
    const identificationTypes = this.identificationTypeList || [];
    this.primaryIdList = this.showAllIdentificationTypes
      ? identificationTypes
      : identificationTypes.filter((i) => i.isPrimaryId);
    this.primaryIdFilteredList = this.primaryIdList;
    this.secondaryIdList = this.showAllIdentificationTypes
      ? identificationTypes
      : identificationTypes.filter((i) => !i.isPrimaryId);
    this.secondaryIdFilteredList = this.secondaryIdList;
    this.primaryIdListNOK = identificationTypes.filter((i) => i.isPrimaryId);
    this.primaryIdFilteredListNok = this.primaryIdListNOK;
  }

  /**
   *It is the source of getGLTypeList data.
   *
   * @memberof PatientRegistrationComponent
   */
  getGLTypeList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_GLTYPE)
        .subscribe((data: any) => {
          this.glTypeList = data;
        })
    );
  }

  /**
   *Change Priority
   *
   * @param {boolean} moveUp
   * @param {number} index
   * @memberof SamplePatientRegistrationComponent
   */
  changePayerPriority(moveUp: boolean, index: number) {
    let list = this.dataSourcePayers.data;
    var element = list[index];
    if (moveUp && index > 0) {
      list.splice(index, 1);
      list.splice(index - 1, 0, element);
    } else if (!moveUp && index != list.length - 1) {
      list.splice(index, 1);
      list.splice(index + 1, 0, element);
    }
    this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(list);
  }

  /**
   *remove payer
   *
   * @param {*} index
   * @memberof SamplePatientRegistrationComponent
   */
  removePayer(element) {
    let list = this.dataSourcePayers.data;
    const index: number = list.indexOf(element);
    list.splice(index, 1);
    this.dataSourcePayers = new MatTableDataSource<any>(list);
  }

  /**
   *Add payer
   *
   * @memberof SamplePatientRegistrationComponent
   */
  addPayer() {
    let list = this.dataSourcePayers.data;
    let patientEncounterPayer = new PatientEncounterPayer();
    patientEncounterPayer.payerCode = "";
    patientEncounterPayer.priority = list.length + 1;
    if(!this.isFirstPayerPriority){
      list.push(new PatientEncounterPayer());
    }else{
      list.unshift(new PatientEncounterPayer());
    }
    this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(list);
  }

  /**
   *Passing payerCode and index to get the contractList
   *
   * @param {*} payerCode
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  getPayerListData(payerTypeCode, element) {
    let resPayerCode = this.payerTypeList.find((s) => s.code == payerTypeCode);
    if (resPayerCode.isSelf && this.dataSourcePayers.data.length > 1) {
      let index = this.dataSourcePayers.data.indexOf(element);
      this.dataSourcePayers.data[index].payerTypeCode = "";

      this.snackBar.open(
        this.langService.get("CommonAppoinment.selectotherpayertype"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 2000,
        }
      );
    } else {
      let res = this.payerList.find((s) => s.isSelf == resPayerCode.isSelf);
      this.dataSourcePayers.data[0].payerCode = res ? res.code : "";
    }
  }

  /**
   *Add internal notes
   *
   * @memberof SamplePatientRegistrationComponent
   */
  addInternalNotes() {
    const dialogRef = this.dialog.open(PatientNotesDialogComponent, {
      height: "350px",
      width: "1000px",
      data: {
        listNotes: this.previousInternalNotes,
        name: "Emergency",
        encounterno: this.internotesEncounterid,
        encounterId:this.internotesEncounterNo,
        isPrint:false
      },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        let res = result;
        this.internalNotesList = res;
      })
    );
  }

  isSameDate(date1, date2) {
    return date1.getFullYear() == date2.getFullYear() &&
           date1.getMonth() == date2.getMonth() &&
           date1.getDate() == date2.getDate();
  }
  
  isLeapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0);
  }

  isValidDate(year, month, day) {
    if (month < 1 || month > 12) {
      return false;
    }
  
    let daysInMonth;
    if (month == 2) {
      daysInMonth = this.isLeapYear(year) ? 29 : 28;
    } else if ([4, 6, 9, 11].includes(month)) {
      daysInMonth = 30;
    } else {
      daysInMonth = 31;
    }
    return day > 0 && day <= daysInMonth;
  }

  // getTariffContract(contractCode,index){
  //   this.contractValue = this.dataSourcePayers.data[index].contractList.find(i => i.code === contractCode);
  //   if (this.contractValue) {
  //     let tariffContract = this.tariffList.find(i=>i.code==this.contractValue.tariffMaster.code)
  //     if(tariffContract){
  //     this.dataSourcePayers.data[index].tariffCode = tariffContract.code
  //    }
  //   }
  // }

  getTariffContractPayer(payerCode: string, index: number) {
    if (payerCode) {
      this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
      this.appBaseService
        .getResource(OPD_API_URL.GET_COMPANY_TARIFF_BY_COMPANYCODE + payerCode)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res: any) => {
          if (res.companyMasterDTOResponse) {
            if (res.companyMasterDTOResponse.tariffResponseList.length > 0) {
            this.dataSourcePayers.data[index].tariffList = res.companyMasterDTOResponse.tariffResponseList;
          }
        }
        });
    }
  }
  
  getTariffContract(contractCode: string, index: number) {
    this.contractValue = this.dataSourcePayers.data[index].contractList.find(i => i.code === contractCode);
    
    if (this.contractValue) {
      let tariffContract = this.tariffList.find(i=>i.code==this.contractValue.tariffMaster.code)
      
      if (tariffContract) {
        this.dataSourcePayers.data[index].tariffCode = tariffContract.code;
        this.dataSourcePayers.data[index].isDisableTariff = true;
      } else {
        this.dataSourcePayers.data[index].isDisableTariff = false;
      }
    }
  }
  getContractPayer(payerCode,index){
    this.dataSourcePayers.data[index].contractList = [];
    this.dataSourcePayers.data[index].contractCodeList = [];
   let payerId =  this.dataSourcePayers.data[index].payerList.find(i=> i.code ==payerCode);
    this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
    this.appBaseService
      .getResource(
        OPD_API_URL.GET_PAYERTYPE_TYPE  +
        "payerId="+payerId.id+"&visitTypeCode=ER"
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        let data = res;
        this.dataSourcePayers.data[index].contractList = data;
        this.dataSourcePayers.data[index].contractCodeList = data;
      })
  }
  getPayerTypePayer(payerCode,index){
    this.dataSourcePayers.data[index].payerList = []
    this.dataSourcePayers.data[index].payerFilteredList = []
    let payerTypeId =   this.payerTypeList.find(i=>i.code ==payerCode);
     this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
     this.appBaseService
       .getResource(
         OPD_API_URL.GET_CONTRACT_PAYER  +
         payerTypeId.id
       )
       .pipe(takeUntil(this._onDestroy))
       .subscribe((res) => {
         let data = res;
        if (!this.selectedPatient) {
        let resdata = data.find(s => s.isSelf == true);
        if (resdata) {
          this.dataSourcePayers.data[index].payerCode = resdata.code; 
        }
      }
        this.dataSourcePayers.data[index].payerList = data;
        this.dataSourcePayers.data[index].payerFilteredList = data;
        this.getContractPayer(this.dataSourcePayers.data[index].payerCode,index);
       })
   }
   getPreviousPayerList(mrn?) {
    this.existingPayerList = [];
    let glattachmentList = [];
    let mrnValue=mrn?mrn:"";
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.OPD_PAYER_ALL_DETAILS + mrnValue+"&visitType="+"OP")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if (res.length > 0) {
          res.forEach((ele) => {
            let referralNoList = [];
            glattachmentList = ele.glAttachmentList
              ? ele.glAttachmentList
              : null;
            if (glattachmentList && glattachmentList.length > 0) {
              glattachmentList.forEach((element) => {
                let list = {
                  glrefno: element.glAttachmentNo ? element.glAttachmentNo : "",
                  glbalance: element.availableBal ? element.availableBal : 0,
                  effectiveDate: element.effectiveDate
                    ? element.effectiveDate
                    : "",
                  expiryDate: element.expiryDate ? element.expiryDate : "",
                
                  glTypeCode: element.glType ? element.glType.code : "",
                  polictyNo: element.glReferenceNo ? element.glReferenceNo : "",
                };
                referralNoList.push(list);
              });
            }
            let obj = {
              payerTypeCode: ele.payerType ? ele.payerType.code : "",
              payerCode: ele.payer ? ele.payer.code : "",
              tariffCode: ele.tariff ? ele.tariff.code : "",
              glTypeCode:
              ele.company && ele.company.isAutoApproval
              ? statisGlApprovalType.AG
              : statisGlApprovalType.PG,
              effectiveDate:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].effectiveDate
                  : "",
              expiryDate:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].expiryDate
                  : "",
              isexpirypayerDate:true,
              glAmount:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].glbalance
                  : "",
              glReferenceNo:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].glrefno
                  : "",
              policyNumber:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].polictyNo
                  : "",
              contractCode: ele.contract ? ele.contract.code : "",
              associatedCompanyCode: ele.associatedCompany
                ? ele.associatedCompany.code
                : "",
              isSelf: ele.payerType.code === "SELF" ? true : false,
              referralNoList: referralNoList,
              tariffList: [],
            };
            this.existingPayerList.push(obj);
          });
          this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(
            this.existingPayerList
          );
          // this.getContractListData();
          // this.getTariffmaster();
          this.getPayerList();
          this.existingPayerList.forEach((element ,i)=> {
          this.getPayerTypePayer(element.payerTypeCode,i);
          this.getTariffList(this.patientCategoryValue,i,false);
          });
        }
      });
  }

  setPatternToMobileNumber(event){
     if (event.regex) {
      const regexPattern = event.regex.replace(/^\/|\/$/g, '');
      this.formRegistration.controls["mobileNumber"].setValidators([
        Validators.pattern(new RegExp(regexPattern))
      ]);
      const matches = event.regex.toString().match(/\{(\d+),(\d+)\}/);
      if (matches && matches.length > 1) {
        this.mobileNoMax = Number(matches[2]);
        this.mobileNoMin = Number(matches[1]);
      }else{
      this.formRegistration.controls["mobileNumber"].clearValidators();
      }
    } else {
      this.formRegistration.controls["mobileNumber"].clearValidators();
    }
    this.formRegistration.controls["mobileNumber"].updateValueAndValidity();
  }
  getGlType(element,index){
    let selectedPayer=element.payerList.find(e => e.code == element.payerCode );
     this.dataSourcePayers.data[index].glTypeCode = selectedPayer?.isAutoApproval ? statisGlApprovalType.AG : statisGlApprovalType.PG;
  }
  checkFields(event: any) {
    event.checked ? this.showFields = event.checked :this.showFields = event ;
    if(this.showFields == true){
      this.isDisabledName = true;
      this.getFirstName();
    }else{
      this.isDisabledName = false;
      if (this.ispatientNameLtwo){
     this.formRegistration.controls["firstNameTh"].setValue(""); 
    }else if(this.isFullName){
      this.formRegistration.controls["fullName"].setValue("");
    }else{
      this.formRegistration.controls["firstName"].setValue("");
    }
      this.updateNameValidators();
    }
  }

  
    /**
   *It is the source of country data.
   *
   * @memberof SamplePatientRegistrationComponent
   */
   getCountryList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_COUNTRY)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.countryList = data;
        this.countryPrimaryList = data;
      });
  }
  //   getCityList() {
  //   this.masterApiService
  //     .getTypeMaster(OPD_API_URL.M_CITY)
  //     .pipe(takeUntil(this._onDestroy))
  //     .subscribe((data: any) => {
  //       this.cityNewPrimaryList = data;
  //     });
  // }
  //   getAreaList() {
  //   this.masterApiService
  //     .getTypeMaster(OPD_API_URL.M_AREA)
  //     .pipe(takeUntil(this._onDestroy))
  //     .subscribe((data: any) => {
  //       this.areaNewPrimaryList = data;
  //     });
  // }

    /**
   *Passing countryCode to get the stateList
   *
   * @param {*} countryCode
   * @memberof EmergencyRegistrationComponent
   */
   getStatePrimaryList(countryCode, isCode) {
    if (countryCode) {
      let result: any = "";
      if (isCode)
        result = this.countryPrimaryList.find((i) => i.code == countryCode);
      else
        result = this.countryPrimaryList.find(
          (i) => i.code == countryCode.code
        );
      this.CountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.statePrimaryList = res;
          if (this.selectedPatient) {
            const stateres = this.statePrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.state
                  : "")
            );
            this.stateValue = stateres ? stateres.code : "";
            this.getCityPrimaryList(stateres);
          }
        });
    }
  }

  /**
   *Passing stateCode to get the cityList
   *
   * @param {*} stateCode
   * @memberof EmergencyRegistrationComponent
   */
  getCityPrimaryList(stateCode) {
    if (stateCode) {
      const result = this.statePrimaryList.find(
        (i) => i.code == stateCode.code
      );
      this.StateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };

      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.cityPrimaryList = res;
          if (this.selectedPatient) {
            const cityres = this.cityPrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.city
                  : "")
            );
            this.cityValue = cityres ? cityres.code : "";
            this.getSubDistrictPrimaryList(cityres);
          }
        });
    }
  }

  /**
   *Passing cityCode to get the subDistrictList
   *
   * @param {*} cityCode
   * @memberof EmergencyRegistrationComponent
   */
  getSubDistrictPrimaryList(cityCode) {
    if (cityCode) {
      const result = this.cityPrimaryList.find((i) => i.code == cityCode.code);
      this.CityCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: result.id,
      };

      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.subDistrictPrimaryList = res;
          if (this.selectedPatient) {
            const distres = this.subDistrictPrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.area
                  : "")
            );
            this.districtValue = distres ? distres.code : "";
            this.postCodeValue = distres ? distres.postCode : "";
          }
        });
    }
  }
  updateVIPStatus(event) {
    // if(event.checked) {
    //   this.isVip = true;
    //   this.formRegistration.controls["isVip"].setValue(true);
    //   this.formRegistration.controls["aliasName"].enable();
    //   this.formRegistration.updateValueAndValidity();
    // } else {
    //   this.isVip = false;
    //   this.formRegistration.controls["isVip"].setValue(false);
    //   this.formRegistration.controls["aliasName"].setValue("");
    //   this.formRegistration.controls["aliasName"].disable();
    //   this.formRegistration.updateValueAndValidity();
    // }
  }
     addIdentification(element): void {
      const { idType, idNumber, expDate, issuingCountry, type, isIdNumberValid } = element;
    
      if (!idType || !idNumber.replace(/-/g, '')) {
        this.snackBar.open("Please enter identification details", "validation", { duration: 2000 });
        return;
      }
      if(!isIdNumberValid){
        this.snackBar.open("Please enter valid identification Number","Validation",{duration:2000});
        return;
      }
      const idTypeCode:any = this.getObjByCode(
        type === 'P' ? this.primaryIdFilteredList : this.secondaryIdFilteredList,
        idType
      );
    
      if (idTypeCode.isExpireReq && !expDate) {
        this.snackBar.open("Please enter expiry date", "validation", { duration: 2000 });
        return;
      }
    
      if (idTypeCode.isCountryRequired && !issuingCountry) {
        this.snackBar.open("Please enter issuing country", "validation", { duration: 2000 });
        return;
      }
      const hasEmptyEntry = this.identificationList.data.some(
        item => !item.idType && !item.idNumber
      );
    
      if (hasEmptyEntry) {
        this.snackBar.open("Blank identification entry already exists", "validation", { duration: 2000 });
        return;
      }
     const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "30%",
      data: { displayText: "Do you want to Add another identification entry?" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
          this.addEmptyIdentificationEntry("S");
          this.secondaryIdentifierListModified = true;
        }
      })
    );
      
    }
    
    hasPrimarySelected(): boolean {
      return this.identificationList.data.some(item => item.type === 'P');
    }
    isIdTypeSelected(code: string, currentIndex: number): boolean {
      if(this.identificationList.data[currentIndex].type=="S"){
      return this.identificationList.data
        .some((item, index) => index !== currentIndex && item.idType === code);
      }
    }
    onTypeChange(element: string, index: number): void {
      this.identificationList.data[index].type=element;
      if (element === 'P') {
        this.identificationList.data.forEach((item, i) => {
          if (i !== index && item.type === 'P') {
            item.type = 'S';
          }
        });
      }
      this.identificationList.data[index].idType="";
      this.identificationList.data[index].idNumber="";
      this.identificationList.data[index].expDate="";
      this.identificationList.data[index].issuingCountry="";
      this.identificationList.data = [...this.identificationList.data]; 
    }
    setCountryValue(event: any, index: number, element: any): void {
      this.identificationList.data[index].issuingCountry = event;
  
      if (element.identifierUUID && this.patientId) {
        element.identifierOverride = true;
        element.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
      }
    }
    onExpiryDateChange(selectedDate: Date, element: any): void {
      element.expDate = selectedDate;
      if (element.identifierUUID && this.patientId) {
        element.identifierOverride = true;
        element.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
      }
    }
    deleteIdentification(index: number,element): void {
      if(this.selectedPatientIdentificationList && element.identifierUUID){
        const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "30%",
          data: { displayText: "deleteConfirm" },
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result != undefined && result.confirm && result.confirm == "yes") {
              this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
              this.appBaseService
                .deleteResource(OPD_API_URL.DELETE_IDENTIFICATION+this.patientId+"&identifierUUID="+element.identifierUUID)
                .subscribe((res) => {
                  if(res.statusCode="200"){
                    this.snackBar.open(res.message,"Success",{duration:2000});
                  if (index !== 0) {
                    const data = this.identificationList.data;
                    data.splice(index, 1);
                    this.identificationList.data = [...data];
                  }
                }
                });
            }
          })
        );
      }else{
      if (index !== 0) {
        const data = this.identificationList.data;
        data.splice(index, 1);
        this.identificationList.data = [...data];
      }
    }
    }
    copyPrimaryId(element: any, index: number): void {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "30%",
      data: { displayText: "Do you want to copy the primary identification?" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
          
      if(element.idType && element.idNumber){
      const original = this.selectedPatientIdentificationList.find(
        (item) => item.type === 'P' && !item.isCopied 
      );
    
      if (original) {
        const copiedElement = { ...original };
        copiedElement.isCopied = true;
        copiedElement.status = false;
        this.selectedPatientIdentificationList.push(copiedElement);
        original.idType = '';
        original.idNumber = '';
        original.expDate = '';
        original.issuingCountry = '';
        original.identifierUUID=undefined;
        original.isExpiryRequired=false;
        original.isCountryRequired=false;
        original.isCopied=false;
        this.primaryIdentifierListModified = true;
        this.identificationList.data = this.selectedPatientIdentificationList;
      }
      }
        }
      })
    );
    }
    addEmptyIdentificationEntry(type: 'P' | 'S'): void {
      this.identificationList.data.push({
        type: type,
        idType: '',
        idNumber: '',
        expDate: '',
        issuingCountry: '',
        maxIdentificationLength: 25,
        minIdentificationLength: 0,
        primaryIdRegex: OPD_CONST.primaryIdRegix,
        isIdNumberValid:true
      });
    
      this.identificationList.data = [...this.identificationList.data];
    }
     checkDuplicatePatient(from, idDetails?) {
          if (this.duplicateCheckCalled[from]) return;
          let request: any = {};
      
          if (from === dupicatePatient.identificationNo) {
            request = {
              identificationId: idDetails.idNumber.includes("-") ? idDetails.idNumber.split("-").join("") : idDetails.idNumber,
              identificationType: idDetails.idType
            };
            if (!idDetails.idNumber.replace(/-/g, '') || !idDetails.idType) return;
          } else if (from === dupicatePatient.dateOfBirth) {
            const name = `${this.formRegistration.controls['firstName']?.value ?? ''}`.trim();
            const gender = this.formRegistration.controls['gender']?.value?.code;
            const birthDate = this.datepipe.transform(this.formRegistration.controls['dateOfBirth']?.value, "yyyy-MM-dd");
      
            if (!name || !gender || !birthDate) return;
            request = { name, gender, birthDate };
          } else if (from === dupicatePatient.mobileNumber) {
            const birthDate = this.datepipe.transform(this.formRegistration.controls['dateOfBirth']?.value, "yyyy-MM-dd");
            const mobile = this.formRegistration.controls['mobileNumber']?.value?.replace(/-/g, '');
      
            if (!mobile || !birthDate) return;
            request = { mobile, birthDate };
          }
          let isNewBorn = this.formRegistration.controls['isNewborn']?.value==true?true:false;
      
          this.dupicatePatientService.checkForDuplicatePatients(request, from, isNewBorn,this.isUnitWisePatientSearch,this.selectedPatient).subscribe((response: any) => {
            const markAllChecked = () => {
              this.duplicateCheckCalled = {
                identificationNo: true,
                dateOfBirth: true,
                mobileNumber: true
              };
            };
      
    this.duplicateCheckCalled[from] = true;
            if (response === 'No') {
              markAllChecked();
            } else if (response?.id) {
              const patientData = this.patientDataService.displayList([response]);
              this.getPatientData(patientData[0]);
              this.uhId = response.uhId ?? null;
              this.isFromAnotherunit = response.isFromAnotherUnit ?? false;
              markAllChecked();
            }
            if (response === "DUPLICATE") {
              this.duplicateCheckCalled[from] = false;
              let existingIdentification = this.selectedPatient.primaryIdentificationList;
              this.identificationList.data.forEach(element => {
                let existId = existingIdentification.find(i => i.display == element.idType && i.value == element.idNumber);
                if (existId && element.identifierUUID && !element.isCopied) {
                  element.idNumber = "";
                  this.snackBar.open("Duplicate Identification Number", "Validation", { duration: 2000 });
                } else if (existId && !element.identifierUUID) {
                  element.idNumber = "";
                  this.snackBar.open("Duplicate Identification Number", "Validation", { duration: 2000 });
                } else if (!existId && !element.identifierUUID) {
                  element.idNumber = "";
                  this.snackBar.open("Duplicate Identification Number", "Validation", { duration: 2000 });
                }
              });
            }
          });
     }
    
  /**
   * Delete Next of Kin
   * @param {*} element
   * @memberof EmergencyRegistrationComponent
   * @description Deletes the next of kin entry from the list and the server if it has an ID.
   */

  deleteNextOfKin(element) {
    if (element.id) {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "Do you want Delete Nok?" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {
            let id = element.id ? element.id : "";
            this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
            this.subscriptionList.add(
              this.appBaseService
                .getResource(OPD_API_URL.DELETE_NEXT_OF_KIN + id)
                .subscribe((res) => {
                  this.snackBar.open("Next of Kin Deleted", "Success", {
                    duration: 2000,
                  });
                  const index: number = this.nokList.indexOf(element);

                  if (index != -1) {
                    this.nokList.splice(index, 1);
                    this.dataSourceNextOfKin = new MatTableDataSource(this.nokList);
                  }
                })
            );
          }
        })
      );
    } else {
      const index: number = this.dataSourceNextOfKin.data.indexOf(element);

      let list = this.dataSourceNextOfKin.data;
      list.splice(index, 1);
      this.dataSourceNextOfKin = new MatTableDataSource<any>(list);
    }
  }

  /**
   * Set Guarantor Value
   * @param {*} selectedElement
   * @memberof EmergencyRegistrationComponent
   * @description Sets the selected next of kin as the guarantor and ensures only one guarantor is selected at a time.
   * If no guarantor is selected, it shows a snackbar message prompting the user to select a guarantor.
   * @returns {void}
   * @description If only one next of kin is present and no guarantor is selected, it prompts the user to select a guarantor.
   */
  setGuarantorValue(selectedElement: any) {
     if (this.isKinGuarantorRequired) {
    if (selectedElement.isGuarantor) {
      selectedElement.isGuarantor = false;
    } else {
      this.nokList.forEach((item: any) => {
        item.isGuarantor = false;
      });
      selectedElement.isGuarantor = true;
    }

    const guarantorCount = this.kinData.filter(
      (item) => item.isGuarantor
    ).length;
    if (this.kinData.length == 1 && guarantorCount == 0) {
      this.snackBar.open(
        this.langService.get('CommonAppoinment.PleaseSelectGuarenter'),
        this.langService.get('CommonAppoinment.validation'),
        { duration: 2000 }
      );
    }
    if (this.kinData.length > 1 && guarantorCount == 0) {
      this.snackBar.open(
        this.langService.get('CommonAppoinment.PleaseSelectGuarenter'),
        this.langService.get('CommonAppoinment.validation'),
        { duration: 2000 }
      );
    }
  }
  }

  /**
   *validate kin form
   *
   * @return {*}  {boolean}
   * @memberof EmergencyRegistrationComponent
   * @description Validates the next of kin form by marking all controls as touched and checking if the form is valid.
   */
  validateNextOfKinForm(): boolean {
    for (var i in this.formNextOfKin.controls) {
      this.formNextOfKin.controls[i].markAsTouched();
    }
    return this.formNextOfKin.valid;
  }

  /**
   *add next kin
   *
   * @memberof EmergencyRegistrationComponent
   * @description Validates the next of kin form and adds the next of kin details to the list.
   */
    addNextOfKin(value: string) {
    if (value && value.trim() === 'add') {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "Do you want Add Nok?" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {
            if (this.validateNextOfKinForm()) {
              let nextOfKin: PatientNextOfKin =
                this.patientRegService.getNextOfKinFormValues(this, this.formNextOfKin);
              nextOfKin.checked = true;
              if (nextOfKin) {
                let list = this.dataSourceNextOfKin.data;
                list.push(nextOfKin);
                this.dataSourceNextOfKin = new MatTableDataSource<any>(list);
                this.formNextOfKin.reset();
                this.getNokforSave(nextOfKin,nextOfKin);
              }
            } else {
              this.snackBar.open(
                "Please fill all required fields",
                "Validation",
                { duration: 2000 }
              );
            }
          }
        })
      );
    } else {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "Do you want Update Nok?" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {
            let nextOfKin: any =
              this.patientRegService.getNextOfKinFormValues(this, this.formNextOfKin);
            var index = this.dataSourceNextOfKin.data.findIndex(
              kin => kin?.iid === this.nokIid || kin?.id?.toString() === this.nokId
            );
            this.dataSourceNextOfKin.data.forEach((kin) => {
              if (kin.iid?.toString() === this.nokId) {
                nextOfKin.iid = this.nokIid;
              } else if (kin.id?.toString() === this.nokId) {
                nextOfKin.id = this.nokId;
              }
            });

            if (index !== -1) {
              this.dataSourceNextOfKin.data[index] = nextOfKin;
            } else {
              this.snackBar.open('No matching record found to replace', 'Validartion', {
                duration: 2000
              });
            }
            this.dataSourceNextOfKin._updateChangeSubscription();
            this.isEditNok = false;
            this.formNextOfKin.reset();
            this.getNokforSave(nextOfKin,nextOfKin);
            this.saveNextOfKin();
          }
        })
      );
    }
     return this.formNextOfKin.controls["name"].valid;
  }
  /**
   *
   *
   * @param {*} event
   * @param {*} value
   * @memberof EmergencyRegistrationComponent
   */
  getNokforSave(event, value) {
    if (event.checked) {
      value.active = true;
      this.kinData.push(value);
    } else {
      value.active = false;
      const indexToRemove = this.kinData.findIndex(
        (nok) => nok.name === value.name
      );
      if (indexToRemove !== -1) {
        this.kinData.splice(indexToRemove, 1);
      }
    }
    const guarantorCount = this.kinData.filter(
      (item) => item.isGuarantor
    ).length;
    if (this.isKinGuarantorRequired && guarantorCount > 1 ) {
      this.kinData.forEach((item) => (item.isGuarantor = false));
      this.snackBar.open(
        this.langService.get('CommonAppoinment.PleaseSelectGuarenter'),
        this.langService.get('CommonAppoinment.validation'),
        { duration: 2000 }
      );
    }
    if (this.isKinGuarantorRequired && (this.kinData.length == 1 || guarantorCount == 0) ) {
      this.snackBar.open(
        this.langService.get('CommonAppoinment.PleaseSelectGuarenter'),
        this.langService.get('CommonAppoinment.validation'),
        { duration: 2000 }
      );
    }
    const existingIndex = this.dataSourceNextOfKin.data.findIndex(
      (nok) => nok.name === value.name
    );
    if (existingIndex !== -1) {
      this.dataSourceNextOfKin.data[existingIndex] = value;
    } else {
      this.dataSourceNextOfKin.data.push(value);
    }
  }

  /**
   *Passing CountryCode to get the kinStateList
   *
   * @param {*} countryCode
   * @memberof EmergencyRegistrationComponent
   */
  getNOKStateList(countryCode) {
    if (countryCode && countryCode.id) {
      this.nokCountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: countryCode.id,
      };
    }
  }

  /**
   *Passing cityCode to get the kinCityList
   *
   * @param {*} cityCode
   * @memberof EmergencyRegistrationComponent
   */
  getNOKCityList(cityCode) {
    if (cityCode && cityCode.id) {
      this.nokStateCode = {
        field: OPD_API_URL.M_STATEM,
        value: cityCode.id,
      };
    }
  }

  /**
   *Passing cityCode to get the subDistrictList
   *
   * @param {*} city as object
   * @memberof EmergencyRegistrationComponent
   */
  getSubDistrictForNOK(city) {
    if (city) {
      this.nokAreaCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: city.id,
      };
    }
  }

  /**
   * To load pincode based on district
   * @param district as object
   * @memberof EmergencyRegistrationComponent
   */
  NOKDistrictSelected(district) {
    this.formNextOfKin.patchValue({
      postcode: district.postCode,
    });
  }

  /**
   *
   *
   * @param {MatTabChangeEvent} e
   * @memberof EmergencyRegistrationComponent
   */
  onTabChange(e: MatTabChangeEvent) {
    if (e.index == 0) {
      this.showDefaultDeposit = true;
    } else {
      this.showDefaultDeposit = false;
    }
  }
  displayAddressDetails(element){
    const address = element.address || '';
    const country = element.country?.code?.desc  || '';
    const state = element.state?.desc || '';
    const city = element.city?.desc  || '';
    const postcode = element.postcode || '';
    const area = element.area?.desc || '';

  
    const fullAddress = [address, country, state, city,area, postcode]
      .filter(val => val)
      .join(', ');
     this.dialog.open(InfoDialogComponent, {
            width: "30%",
            data: {
              display: "Address Details",
              info: fullAddress 
            }
          });
  }
  editNOK(element) {
  this.isEditNok=true;
  this.nokId = element.id ? element.id : '';
    this.nokIid = element.iid ? element.iid : '';

    this.titleDefaultValue = element.prefix?.code?.code || "";
    this.relationDefaultValue = element.relation?.code?.code || "";
    this.countryDefaultValue = element.country?.code?.code || "";
    this.areaDefaultValue = element.area?.code?.code || "";
    this.stateDefaultValue = element.state?.code || "";
    this.cityDefaultValue = element.city?.code || "";

    this.formNextOfKin.patchValue({
      prefix: element.prefix.code || "",
      name: element.name || "",
      identificationType: element.identificationType.code || "",
      identificationNumber: element.idNumber || "",
      relation: element.relation.code || "",
      phoneNumber: element.phoneNumber || "",
      isGuarantor: element.isGuarantor || false,
      address: element.address || "",
      country: element.country.code || "",
      state: element.state.code || "",
      city: element.city.code || "",
      area: element.area.code || "",
      district: [""],
      postcode: element.postcode || "",
    });
}
 getNOKList() {
  this.nokList = [];
  this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);

  this.subscriptionList.add(
    this.appBaseService
      .getResource(OPD_API_URL.GET_NOK_LIST + "patientId=" + this.patientId)
      .subscribe((res) => {
        const observables: Observable<PatientNextOfKin>[] = [];

        if (res) {
          res.forEach((element) => {
            if (element.active === true) {
              const nextOfKin: PatientNextOfKin =
                this.patientRegService.getNextOfKinValues(this, element);

              if (nextOfKin.country?.code) {
                const updatedKin$ = this.getNOKStateList1(nextOfKin.country.code, nextOfKin.state.code).pipe(
                  switchMap((matchedState) => {
                    if (matchedState) {
                      nextOfKin.state.code = matchedState;
                      return this.getNOKCityList1(matchedState, nextOfKin.city.code);
                    } else {
                      return of(null);
                    }
                  }),
                  switchMap((matchedCity) => {
                    if (matchedCity) {
                      nextOfKin.city.code = matchedCity;
                      return this.getNOKAreaListForGet(matchedCity, nextOfKin.area.code);
                    } else {
                      return of(null);
                    }
                  }),
                  map((matchedArea) => {
                    if (matchedArea) {
                      nextOfKin.area.code = matchedArea;
                    }
                    return nextOfKin;
                  })
                );
                observables.push(updatedKin$);
              } else {
                observables.push(of(nextOfKin));
              }
            }
          });

          if (observables.length > 0) {
            forkJoin(observables).subscribe((finalList: PatientNextOfKin[]) => {
              this.nokList = finalList;
              this.dataSourceNextOfKin = new MatTableDataSource<any>(this.nokList);
              this.nokList.forEach(item => {
                item.checked = true;
                this.getNokforSave({ checked: true }, item);
              });
            });
          } else {
            this.nokList = [];
            this.dataSourceNextOfKin = new MatTableDataSource<any>([]);
          }
        }
      })
  );
}


  getNOKCityList1(stateCode: any, cityCode: string): Observable<any> {
      if(stateCode && stateCode.id){
    const url = OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + stateCode.id;
    return this.masterApiService.getTypeMaster(url).pipe(
      takeUntil(this._onDestroy),
      map((res: any[]) => res.find((item) => item.code === cityCode))
    );}
  }
  getNOKStateList1(countryCode: any, statecode: string): Observable<any> {
      if(countryCode && countryCode.id){
    const url = OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + countryCode.id;
    return this.masterApiService.getTypeMaster(url).pipe(
      takeUntil(this._onDestroy),
      map((res: any[]) => {
        return res.find((item) => item.code === statecode);
      })
    );}
  }
   getNOKAreaListForGet(cityCode: any, areaCode): Observable<any> {
      if (cityCode && cityCode.id) {
        const url = OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + cityCode.id;
        return this.masterApiService.getTypeMaster(url).pipe(
          takeUntil(this._onDestroy),
          map((res: any[]) => res.find((item) => item.code === areaCode))
        );
      }
      return of(null);
    }
   getPrefixList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_PREFIX, true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.prefixList = data;
      });
  }
   getRelationList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_RELATION, true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.relationList = data;
      });
  }
   saveNextOfKin() {
    if (this.dataSourceNextOfKin.data.length > 0) {
      this.dataSourceNextOfKin.data.forEach(item => {
        item.active = true;
      });
      const listWithId = this.dataSourceNextOfKin.data.filter(item => !!item.id);
      let nextOfKin: any =
        this.patientRegService.getNextOfKinList(listWithId);

      let payload = {
        patientId: this.patientId,
        encounterId: this.internotesEncounterid,
        kinDetailsDTOList: nextOfKin
      };
      this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
      this.appBaseService
        .postResource(OPD_API_URL.NOK_SAVE_AND_UPDATE, payload)
        .subscribe((res) => {
          if (res.message) {
            this.snackBar.open(res.message, "Success", {
              duration: 2000
            });
            this.formNextOfKin.reset();
            this.isEditNok = false;
          }
        });

    } 
  }
  getTariffList(patientCategoryCode,index,isDefaultTariff) {
    let categoryCode = this.formRegistration.controls["patientCategory"].value?.code || '';
    this.patientCategoryValue = patientCategoryCode? patientCategoryCode : categoryCode;
   
    if (!this.dataSourcePayers || this.dataSourcePayers.data.length > 0) {
      this.masterApiService
        .getTypeMaster(OPD_API_URL.GET_TARIFF_LIST + "patientCategoryCode=" + this.patientCategoryValue + "&companyCode=" + this.dataSourcePayers.data[index].payerCode + "&isPatientCategory=" + this.isPatientCategory)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res: any) => {
          if (res.payload) {
            if (res.payload.length > 0) {
              this.dataSourcePayers.data[index].tariffList = res.payload;
              const defaultTariff = res.payload.find(tariff => tariff.isDefault);
              if (defaultTariff && isDefaultTariff) {
                this.dataSourcePayers.data[index].tariffCode = defaultTariff.code;
              }
            }
          }
        })
    }
  }
 getTariffListOnPatientCategory(patientCategoryCode: string): void {
  if (!this.dataSourcePayers || this.dataSourcePayers.data.length === 0) {
    return;
  }
  this.dataSourcePayers.data.forEach((payer) => {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.GET_TARIFF_LIST +"patientCategoryCode=" + patientCategoryCode +"&companyCode=" +payer.payerCode +"&isPatientCategory=" +this.isPatientCategory)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        if (res.payload?.length > 0) {
          payer.tariffList = res.payload;
          const defaultTariff = res.payload.find(tariff => tariff.isDefault);
          if (defaultTariff) {
            payer.tariffCode = defaultTariff.code;
          }
        }
      });
  });
}
dobValidation(event: any): void {
  const parsedDate = this.encryptionService.validateDOBOnManualyEnter(event.target?.value, this.minDate, this.maxDate);

  if (parsedDate) {
    this.formRegistration.controls['dateOfBirth'].setValue(parsedDate);
    this.formRegistration.controls['dateOfBirth'].setErrors(null);
  } else {
    this.formRegistration.controls['dateOfBirth'].setErrors({ invalidDate: true });
  }
}
editPatient(){
    let element = {
      isEditPatient: true,
      mrn: this.selectedPatient.mrn,
      isadmission: false
    };
    this.router.navigate([opdNavigation.OPD_PATIENT_NAVIGATE]);
    if (this.selectedPatient) {
      let elements = [];
      elements.push(element);
      elements.push(this.selectedPatient);
      let updatedData = JSON.stringify(elements);
      localStorage.setItem("emergencyForm", updatedData);
    } else localStorage.setItem("emergencyForm", JSON.stringify(element));
}
toUpperCase(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
  }
  updateNameValidators(): void {
    const controls = this.formRegistration.controls;
  
    if (this.isFullName) {
      controls['fullName']?.setValidators([Validators.required]);
      controls['fullName']?.updateValueAndValidity();
  
      ['firstName', 'lastName'].forEach(name => {
        controls[name]?.clearValidators();
        controls[name]?.updateValueAndValidity();
      });
  
    } else if (this.ispatientNameLtwo) {
      controls['fullName']?.clearValidators();
      controls['fullName']?.updateValueAndValidity();
  
      ['firstNameTh', 'lastNameTh'].forEach(name => {
        controls[name]?.setValidators([Validators.required]);
        controls[name]?.updateValueAndValidity();
      });
  
    } else {
      controls['fullName']?.clearValidators();
      controls['fullName']?.updateValueAndValidity();
  
      ['firstName', 'lastName'].forEach(name => {
        controls[name]?.setValidators([Validators.required]);
        controls[name]?.updateValueAndValidity();
      });
    }
  }
   validatePayer(element, index) {
    let payerIndex = this.dataSourcePayers.data.findIndex((data, i) => {
      return data.payerCode == element.payerCode && i != index;
    });
    if (payerIndex >= 0) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.Payerisalready"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
      this.dataSourcePayers.data[index].payerCode = "";
    } else {
      let categoryCode = this.formRegistration.controls["patientCategory"].value?.code || '';
      this.getGlType( element, index);
      this.getContractPayer(element.payerCode,index);
      this.getTariffList(categoryCode,index,true)
    }
  }
  getReferralList(referralTypeCode) {
      if (referralTypeCode) {
        this.referralTypeCode = {
          field: OPD_API_URL.M_REFFERALTYPE,
          value: referralTypeCode.id,
        };
        this.isOtherReferral = referralTypeCode.desc.trim() === 'Others';
      }
      else {
        this.isOtherReferral = false; 
      }
    }
  updateExpiryValidation() {
    const patientCategory = this.formRegistration.get('patientCategory')?.value;
    const applyForeignerRule =
      this.isForeignerExpiryMandatory &&
      patientCategory?.isIdentificationExpiryRequired === true;
    this.identificationList.data.forEach(element => {
      const selectedId = this.identificationTypeList.find(
        x => x.code === element.idType
      );
      element.isExpiryDisplayed =
        (selectedId?.isExpireDisplayed ?? false) || applyForeignerRule;
      element.isExpiryRequired =
        element.isExpiryDisplayed &&
        ((selectedId?.isExpireReq ?? false) || applyForeignerRule);
    });
    this.identificationList.data = [...this.identificationList.data];
  }
  isExpiryHeaderRequired(): boolean {
      return this.identificationList.data.some(x => x.isExpiryRequired);
  }
}
